<template>
  <div v-show="styles_loaded && setbrandid" :style="new_style_variables">
    <Header
      :key="updateHeader"
      :logo_link="logo_link"
      :home_link="home_link"
      :header_menu="header_menu"
      :show_basket="show_basket"
      :show_home="true"
      :show_languages="true"
      :basket_number="basket_items_number"
      :logo_image="logo_image"
      @toggleBasket="toggleBasket"
      :lang="lang.toUpperCase()"
      :translations="translations"
      :brandSlug="setbrandid"
    ></Header>

    <div class="page-bg" :style="set_style_variables">
      <div class="yourdetails-banner-container">
        <YourDetailsBanner
          :headline="getrans(banner_headline)"
          :headline_mobile="getrans(banner_headline_mobile)"
          :subheadline="''"
          edit-label="Edit"
          :key="getrans(banner_headline_mobile)"
        >
        </YourDetailsBanner>
      </div>

      <div class="page-content">
        <div
          class="page-content__form"
          :class="showing_basket ? 'page-content__hide-section-on-mobile' : ''"
        >
          <form @submit.prevent="proceedtocheckuser" v-if="loginistrue">
            <div
              class="page-content__form-details page-content__form--box-style"
            >
              <div class="fastest-option">
                <h3 class="page-content__form-title">
                  {{ getrans("Account checkout.") }}
                </h3>
                <div class="fastest-option__outer" :style="rectImage()">
                  <!-- <img src="@/assets/images/Rectangleedge.svg" alt="user image" /> -->
                  <div class="fastest-option__inner">
                    {{ getrans("Fastest option!") }}
                  </div>
                </div>
              </div>

              <p class="bolder-text">
                {{
                  getrans(
                    "Make future bookings faster, view old bookings and manage new ones."
                  )
                }}
              </p>
              <p class="standard-para">
                {{
                  getrans(
                    "If you do not have an account we will create one for you. By selecting this option your data will be used for registration to our platform and you will have access to your booking history, personal data and booking information. Alternatively, if you do not wish to create an account please use the Guest Checkout option."
                  )
                }}
                <!-- <br />
              {{
                getrans(
                  "If you don’t have an existing account, we will create one for you."
                )
              }} -->
              </p>

              <div v-if="setbrandid" class="block-wrap" style="width: 50%">
                <div
                  class="block"
                  :class="`${
                    v$.emailid.$errors.length && emailid
                      ? 'form-group--error error'
                      : 'tick'
                  } ${emailid ? 'hasValue' : ''}`"
                >
                  <input
                    type="text"
                    id="emailid"
                    v-model="emailid"
                    @input="
                      lowerCaseEmail(emailid);
                      v$.emailid.$touch();
                    "
                  />
                  <label for="emailid">
                    {{ getrans("Email Address") }}
                    <span class="form-mandatory">*</span>
                  </label>
                </div>
              </div>

              <div v-if="setbrandid" class="block-wrap" style="width: 50%">
                <div class="block">
                  <div class="page-content__form-proceed">
                    <button type="submit">
                      <i
                        v-if="emailid_loading"
                        class="fas fa-circle-notch fa-spin"
                      ></i>
                      {{ getrans("Checkout Now") }} >>
                    </button>
                  </div>
                </div>
              </div>

              <div v-if="setbrandid" class="block-wrap" style="width: 100%">
                <p class="standard-para">
                  {{
                    getrans(
                      "We take your data privacy very seriously; you can delete your account at any time. Please note any existing guest bookings you have will be made available in the manage my booking area."
                    )
                  }}
                </p>
                <p class="standard-para">
                  {{ getrans("To learn more, visit our") }}
                  <a target="_blank" :href="privacy_policy_link">{{
                    getrans("Privacy Notice")
                  }}</a
                  >.
                </p>
              </div>

              <div style="clear: both"></div>
            </div>
          </form>
          <form
            @submit.prevent="proceedtocheckuser_withoutotp"
            v-if="loginistrue"
          >
            <div class="page-content__form-details--guest">
              <h3 class="page-content__form-title">
                {{ getrans("Guest checkout.") }}
              </h3>

              <div v-if="setbrandid" class="block-wrap" style="width: 50%">
                <div
                  class="block"
                  :class="`${
                    v$.emailid_wo.$error && emailid_wo
                      ? 'form-group--error error'
                      : 'tick'
                  } ${emailid_wo ? 'hasValue' : ''}`"
                >
                  <input
                    type="text"
                    id="emailid_wo"
                    v-model="emailid_wo"
                    @input="
                      lowerCaseEmail(emailid_wo);
                      v$.emailid_wo.$touch();
                    "
                  />
                  <label for="emailid">
                    {{ getrans("Email Address") }}
                    <span class="form-mandatory">*</span>
                  </label>
                </div>
              </div>

              <div v-if="setbrandid" class="block-wrap" style="width: 100%">
                <p class="standard-para">
                  {{
                    getrans(
                      "Please note: As a guest your booking history, personal data and booking information will not be accessible three months after your booking has expired. We take your data privacy very seriously."
                    )
                  }}&nbsp;{{ getrans("To learn more, visit our") }} <br />
                  <a target="_blank" :href="privacy_policy_link">{{
                    getrans("Privacy Notice")
                  }}</a
                  >.
                </p>
              </div>

              <div v-if="setbrandid" class="block-wrap" style="width: 50%">
                <div class="block">
                  <div class="page-content__form-proceed guest-btn">
                    <button type="submit">
                      <i
                        v-if="emailid_loading"
                        class="fas fa-circle-notch fa-spin"
                      ></i>
                      {{ getrans("Guest Checkout") }}
                    </button>
                  </div>
                </div>
              </div>
              <div style="clear: both"></div>
            </div>
          </form>
          <form @submit.prevent="proceedtologinuser" v-if="passistrue">
            <div
              class="page-content__form-details page-content__form--box-style"
            >
              <h3 class="page-content__form-title">
                {{ getrans("Your details") }}
              </h3>

              <h3 class="page-content__form-title">
                {{ getrans("We've sent a 6-digit verification code to") }}
                {{ emailid }}
              </h3>

              <div v-if="setbrandid" class="block-wrap" style="width: 50%">
                <OTPInput v-on:opt_change="opt_change" :otpLength="6" />

                <div
                  style="display: none"
                  class="block"
                  :class="`${
                    v$.password.$errors.length
                      ? 'form-group--error error'
                      : 'tick'
                  } ${password ? 'hasValue tick' : ''}`"
                >
                  <input
                    @input="v$.password.$touch()"
                    type="password"
                    id="password"
                    :readonly="otp_readonly"
                    @focus="otp_readonly = false"
                    v-model="password"
                  />
                  <label for="email">
                    {{ getrans("Enter 6-digit Code from Email") }}
                    <span class="form-mandatory">*</span>
                  </label>
                </div>
              </div>
              <div v-if="setbrandid" class="block-wrap" style="width: 50%">
                <div class="block">
                  <div class="page-content__form-proceed">
                    <button type="submit">
                      <i
                        v-if="proceedtologinuser_loading"
                        class="fas fa-circle-notch fa-spin"
                      ></i>
                      {{ getrans("Login") }}
                    </button>
                  </div>
                </div>
              </div>
              <div style="clear: both"></div>
            </div>
          </form>
          <form
            @submit.prevent="submit"
            v-if="registeristrue"
            id="payment-process"
          >
            <div
              class="page-content__form-details page-content__form--box-style"
            >
              <h3 class="page-content__form-title">
                {{ getrans("Your details") }}
                <div
                  v-if="setbrandid"
                  class="
                    block-wrap
                    block-wrap-question-icon
                    block-wrap-question-icon--in-title
                  "
                  @click="info_your_details = !info_your_details"
                >
                  <i class="fa fa-question-circle"></i>
                </div>
              </h3>

              <div
                v-if="info_your_details"
                class="block-wrap"
                style="width: 100%"
              >
                <div class="info-block">
                  <h4>
                    <i class="fa fa-question-circle"></i>
                    {{ getrans("Why do we need this information?") }}
                  </h4>
                  <p>
                    {{
                      getrans(
                        "The information (personal data) requested on this form is required to process your booking. For further information please visit our FAQ."
                      )
                    }}
                  </p>
                </div>
              </div>

              <div v-if="setbrandid" class="block-wrap" style="width: 100%">
                <div
                  class="block"
                  :class="`${
                    v$.email.$errors.length ? 'form-group--error error' : 'tick'
                  } ${email ? 'hasValue tick' : ''}`"
                >
                  <input
                    type="text"
                    id="email"
                    v-model="email"
                    @input="lowerCaseEmail_Confirm(email)"
                    readonly
                  />
                  <label for="email_confirm">
                    {{ getrans("Email Address") }}
                    <span class="form-mandatory">*</span>
                  </label>
                </div>
              </div>
              <div
                v-if="setbrandid"
                class="block-wrap"
                style="display: none; width: 50%"
              >
                <div
                  class="block"
                  :class="`${false ? 'form-group--error error' : 'tick'} ${
                    email && email !== email_confirm
                      ? 'form-group--error error'
                      : 'tick'
                  } 
                ${email_confirm ? 'hasValue' : ''}`"
                >
                  <input
                    type="text"
                    id="email_confirm"
                    v-model="email_confirm"
                    @input="lowerCaseEmail_Confirm(email_confirm)"
                    readonly
                  />
                  <label for="email_confirm">
                    {{ getrans("Confirm Email Address") }}
                    <span class="form-mandatory">*</span>
                  </label>
                </div>
              </div>

              <div v-if="setbrandid" class="block-wrap" style="width: 20%">
                <div
                  class="block"
                  :class="`${
                    v$.title.$errors.length ? 'form-group--error error' : 'tick'
                  } ${title ? 'hasValue' : ''}`"
                >
                  <select class="styled_select" v-model="title">
                    <option></option>
                    <option>{{ getrans("Mr") }}</option>
                    <option>{{ getrans("Mrs") }}</option>
                    <option>{{ getrans("Rather not say") }}</option>
                  </select>
                  <label for="title">
                    {{ getrans("Title") }}
                    <span class="form-mandatory">*</span>
                  </label>
                </div>
              </div>

              <div v-if="setbrandid" class="block-wrap" style="width: 30%">
                <div
                  class="block"
                  :class="`${
                    v$.firstname.$errors.length
                      ? 'form-group--error error'
                      : 'tick'
                  } ${firstname ? 'hasValue tick' : ''}`"
                >
                  <input type="text" id="firstname" v-model="firstname" />
                  <label for="firstname">
                    {{ getrans("First Name") }}
                    <span class="form-mandatory">*</span>
                  </label>
                </div>
              </div>

              <div v-if="setbrandid" class="block-wrap" style="width: 50%">
                <div
                  class="block"
                  :class="`${
                    v$.surname.$errors.length
                      ? 'form-group--error error'
                      : 'tick'
                  } ${surname ? 'hasValue tick' : ''}`"
                >
                  <input type="text" id="lastname" v-model="surname" />
                  <label for="surname">
                    {{ getrans("Surname") }}
                    <span class="form-mandatory">*</span>
                  </label>
                </div>
              </div>

              <div v-if="setbrandid" class="block-wrap" style="width: 50%">
                <div
                  class="block"
                  :class="`${
                    v$.phonecode.$errors.length
                      ? 'form-group--error error'
                      : 'tick'
                  } ${phonecode ? 'hasValue' : ''}`"
                >
                  <select
                    id="phonecode"
                    v-model="phonecode"
                    class="styled_select"
                    autocomplete="off"
                  >
                    <template v-if="setbrandid === 'RDU'">
                      <option value></option>
                      <option value="+1">USA (+1)</option>
                      <option value="+44">United Kingdom (+44)</option>
                      <option value="+54">Argentina (+54)</option>
                      <option value="+61">Australia (+61)</option>
                      <option value="+43">Austria (+43)</option>
                      <option value="+32">Belgium (+32)</option>
                      <option value="+387">Bosnia (+387)</option>
                      <option value="+1">Canada (+1)</option>
                      <option value="+56">Chile (+56)</option>
                      <option value="+86">China (+86)</option>
                      <option value="+385">Croatia (+385)</option>
                      <option value="+357">Cyprus (+357)</option>
                      <option value="+420">Czech Republic (+420)</option>
                      <option value="+45">Denmark (+45)</option>
                      <option value="+358">Finland (+358)</option>
                      <option value="+33">France (+33)</option>
                      <option value="+49">Germany (+49)</option>
                      <option value="+350">Gibraltar (+350)</option>
                      <option value="+30">Greece (+30)</option>
                      <option value="+852">Hong Kong (+852)</option>
                      <option value="+36">Hungary (+36)</option>
                      <option value="+354">Iceland (+354)</option>
                      <option value="+91">India (+91)</option>
                      <option value="+62">Indonesia (+62)</option>
                      <option value="+353">Ireland (+353)</option>
                      <option value="+972">Israel (+972)</option>
                      <option value="+39">Italy (+39)</option>
                      <option value="+81">Japan (+81)</option>
                      <option value="+962">Jordan (+962</option>
                      <option value="+352">Luxembourg (+352)</option>
                      <option value="+389">Macedonia (+389)</option>
                      <option value="+60">Malaysia (+60)</option>
                      <option value="+356">Malta (+356)</option>
                      <option value="+31">Netherlands (+31)</option>
                      <option value="+64">New Zealand (+64)</option>
                      <option value="+47">Norway (+47)</option>
                      <option value="+968">Oman (+968)</option>
                      <option value="+48">Poland (+48)</option>
                      <option value="+351">Portugal (+351)</option>
                      <option value="+7">Russia (+7)</option>
                      <option value="+966">Saudi Arabia (+966)</option>
                      <option value="+381">Serbia (+381)</option>
                      <option value="+65">Singapore (+65)</option>
                      <option value="+421">Slovakia (+421)</option>
                      <option value="+386">Slovenia (+386)</option>
                      <option value="+27">South Africa (+27)</option>
                      <option value="+82">South Korea (+82)</option>
                      <option value="+34">Spain (+34)</option>
                      <option value="+94">Sri Lanka (+94)</option>
                      <option value="+46">Sweden (+46)</option>
                      <option value="+41">Switzerland (+41)</option>
                      <option value="+886">Taiwan (+90)</option>
                      <option value="+90">Turkey (+886)</option>
                      <option value="+971">United Arab Emirates (+971)</option>
                    </template>
                    <template v-else>
                      <option value></option>
                      <option value="+44">United Kingdom (+44)</option>
                      <option value="+54">Argentina (+54)</option>
                      <option value="+61">Australia (+61)</option>
                      <option value="+43">Austria (+43)</option>
                      <option value="+32">Belgium (+32)</option>
                      <option value="+387">Bosnia (+387)</option>
                      <option value="+1">Canada (+1)</option>
                      <option value="+56">Chile (+56)</option>
                      <option value="+86">China (+86)</option>
                      <option value="+385">Croatia (+385)</option>
                      <option value="+357">Cyprus (+357)</option>
                      <option value="+420">Czech Republic (+420)</option>
                      <option value="+45">Denmark (+45)</option>
                      <option value="+358">Finland (+358)</option>
                      <option value="+33">France (+33)</option>
                      <option value="+49">Germany (+49)</option>
                      <option value="+350">Gibraltar (+350)</option>
                      <option value="+30">Greece (+30)</option>
                      <option value="+852">Hong Kong (+852)</option>
                      <option value="+36">Hungary (+36)</option>
                      <option value="+354">Iceland (+354)</option>
                      <option value="+91">India (+91)</option>
                      <option value="+62">Indonesia (+62)</option>
                      <option value="+353">Ireland (+353)</option>
                      <option value="+972">Israel (+972)</option>
                      <option value="+39">Italy (+39)</option>
                      <option value="+81">Japan (+81)</option>
                      <option value="+962">Jordan (+962</option>
                      <option value="+352">Luxembourg (+352)</option>
                      <option value="+389">Macedonia (+389)</option>
                      <option value="+60">Malaysia (+60)</option>
                      <option value="+356">Malta (+356)</option>
                      <option value="+31">Netherlands (+31)</option>
                      <option value="+64">New Zealand (+64)</option>
                      <option value="+47">Norway (+47)</option>
                      <option value="+968">Oman (+968)</option>
                      <option value="+48">Poland (+48)</option>
                      <option value="+351">Portugal (+351)</option>
                      <option value="+7">Russia (+7)</option>
                      <option value="+966">Saudi Arabia (+966)</option>
                      <option value="+381">Serbia (+381)</option>
                      <option value="+65">Singapore (+65)</option>
                      <option value="+421">Slovakia (+421)</option>
                      <option value="+386">Slovenia (+386)</option>
                      <option value="+27">South Africa (+27)</option>
                      <option value="+82">South Korea (+82)</option>
                      <option value="+34">Spain (+34)</option>
                      <option value="+94">Sri Lanka (+94)</option>
                      <option value="+46">Sweden (+46)</option>
                      <option value="+41">Switzerland (+41)</option>
                      <option value="+886">Taiwan (+90)</option>
                      <option value="+90">Turkey (+886)</option>
                      <option value="+971">United Arab Emirates (+971)</option>
                      <option value="+1">USA (+1)</option>
                    </template>
                  </select>
                  <label for="phonecode">
                    {{ getrans("Country code") }}
                    <span class="form-mandatory">*</span>
                  </label>
                </div>
              </div>

              <div v-if="setbrandid" class="block-wrap" style="width: 50%">
                <div
                  class="block"
                  :class="`${
                    v$.mobilenumber.$errors.length
                      ? 'form-group--error error'
                      : 'tick'
                  } ${mobilenumber ? 'hasValue' : ''}`"
                >
                  <input type="text" id="mobilenumber" v-model="mobilenumber" />
                  <label for="mobilenumber">
                    {{ getrans("Mobile number") }}
                    <span class="form-mandatory">*</span>
                  </label>
                </div>
              </div>

              <div v-if="false" class="block-wrap" style="width: 100%">
                <div
                  class="block"
                  :class="`${
                    v$.country.$errors.length
                      ? 'form-group--error error'
                      : 'tick'
                  } ${country ? 'hasValue' : ''}`"
                >
                  <select
                    id="country"
                    class="styled_select"
                    autocomplete="off"
                    v-model="country"
                    @change="selectcountry"
                  >
                    <option value></option>
                    <option value="GB">{{ "United Kingdom" }}</option>
                    <option value="DE">{{ "Germany" }}</option>
                    <option value="EG">{{ "Egypt" }}</option>
                    <option value="BE">{{ "Belgium" }}</option>
                    <option value="BG">{{ "Bulgaria" }}</option>
                    <option value="DK">{{ "Denmark" }}</option>
                    <option value="FR">{{ "France" }}</option>
                    <option value="IT">{{ "Italy" }}</option>
                    <option value="LI">{{ "Liechtenstein" }}</option>
                    <option value="LU">{{ "Luxembourg" }}</option>
                    <option value="NL">{{ "Netherlands" }}</option>
                    <option value="AT">{{ "Austria" }}</option>
                    <option value="PL">{{ "Poland" }}</option>
                    <option value="RO">{{ "Romania" }}</option>
                    <option value="RU">{{ "Russian Federation" }}</option>
                    <option value="CH">{{ "Switzerland" }}</option>
                    <option value="SI">{{ "Slovenia" }}</option>
                    <option value="CZ">{{ "Czech Republic" }}</option>
                    <option value="UA">{{ "Ukraine" }}</option>
                    <option value="OT">{{ "Other" }}</option>
                  </select>
                  <label for="country">
                    {{ getrans("Country") }}
                    <span class="form-mandatory">*</span>
                  </label>
                </div>
              </div>

              <div
                v-if="setbrandid && billingaddress_api.length > 0"
                class="block-wrap post-code-selection"
                style="width: 100% !important"
              >
                <label
                  v-for="item in billingaddress_api"
                  :key="item.value"
                  class="radio-label"
                >
                  <input
                    type="radio"
                    name="address_id"
                    v-model="addselected"
                    :value="item.value"
                    @change="populateaddress($event)"
                  />
                  {{ item.text }}
                </label>
              </div>

              <div v-if="setbrandid && showaddressfields">
                <template v-if="setbrandid !== 'HER'">
                  <div class="block-wrap" style="width: 50%">
                    <div
                      class="block"
                      :class="`${
                        v$.address.$errors.length
                          ? 'form-group--error error'
                          : 'tick'
                      } ${address ? 'hasValue' : ''}`"
                    >
                      <input type="text" id="address" v-model="address" />
                      <label for="address">
                        {{ getrans("Address Line 1") }}
                        <span class="form-mandatory">*</span>
                      </label>
                    </div>
                  </div>

                  <div class="block-wrap" style="width: 50%">
                    <div
                      class="block"
                      :class="`${address_line_2 ? 'tick hasValue' : ''}`"
                    >
                      <input
                        type="text"
                        id="address_line_2"
                        v-model="address_line_2"
                      />
                      <label for="address">
                        {{ getrans("Address Line 2") }}
                        <span class="form-mandatory"></span>
                      </label>
                    </div>
                  </div>
                </template>

                <div class="block-wrap" style="width: 50%">
                  <div
                    class="block"
                    :class="`${
                      v$.town.$errors.length
                        ? 'form-group--error error'
                        : 'tick'
                    } ${town ? 'hasValue' : ''}`"
                  >
                    <input type="text" id="town" v-model="town" />
                    <label for="town">
                      {{ getrans("Town") }}
                      <span class="form-mandatory">*</span>
                    </label>
                  </div>
                </div>

                <template v-if="setbrandid === 'RDU'">
                  <div class="block-wrap" style="width: 50%">
                    <div
                      class="block"
                      :class="`${
                        v$.state.$errors.length
                          ? 'form-group--error error'
                          : 'tick'
                      } ${state ? 'hasValue' : ''}`"
                    >
                      <input type="text" id="state" v-model="state" />
                      <label for="state">
                        {{ getrans("State") }}
                        <span class="form-mandatory">*</span>
                      </label>
                    </div>
                  </div>
                </template>
              </div>

              <div v-if="country != ''">
                <div v-if="setbrandid" class="block-wrap" style="width: 50%">
                  <div
                    class="block"
                    :class="`${
                      v$.postcode.$errors.length
                        ? 'form-group--error error'
                        : 'tick'
                    } ${postcode ? 'hasValue' : ''}`"
                  >
                    <input
                      type="text"
                      id="postcode"
                      v-model="postcode"
                      @input="
                        postcode_hasError = '';
                        postcode_hasNoError = '';
                      "
                    />
                    <label for="postcode">
                      <template v-if="setbrandid === 'RDU'">
                        {{ getrans("Zipcode") }}
                      </template>
                      <template v-else>
                        {{ getrans("Postcode") }}
                      </template>
                      <span class="form-mandatory">*</span>
                    </label>
                    <div
                      class="postcode-message"
                      style="width: 100%"
                      v-if="country == 'GB'"
                    >
                      {{
                        getrans(
                          "Look up your address using the postcode finder below or to enter your address manually please"
                        )
                      }}
                      <a
                        href="javascript:;"
                        @click.stop="showaddressfields = !showaddressfields"
                        >{{ getrans("click here") }}</a
                      >
                    </div>
                  </div>
                </div>
                <div
                  class="block-wrap"
                  style="width: 33%"
                  v-if="country == 'GB'"
                >
                  <div class="block find-address-btn">
                    <button
                      class="page-content__form-btn"
                      type="button"
                      @click="findyouraddress"
                    >
                      <i
                        v-if="loading_address"
                        class="fas fa-circle-notch fa-spin"
                      ></i>
                      {{ getrans("Find your address") }}
                    </button>
                  </div>
                </div>
              </div>

              <!-- <div class="block-wrap" style="width: 50%">
                <div
                  class="block"
                  :class="`${
                    v$.town.$errors.length ? 'form-group--error error' : 'tick'
                  } ${town ? 'hasValue' : ''}`"
                >
                  <input type="text" id="town" v-model="town" />
                  <label for="town">
                    {{ getrans("Town") }}
                    <span class="form-mandatory">*</span>
                  </label>
                </div>
              </div> -->

              <div style="clear: both"></div>
            </div>

            <!-- VRN section -->

            <div
              class="page-content__form--box-style"
              v-if="cartitem && cartitem.carpark_name"
            >
              <h3 class="page-content__form-title">
                {{ getrans("For Parking Reservation: Vehicle Details") }}
                <div
                  class="
                    block-wrap
                    block-wrap-question-icon
                    block-wrap-question-icon--in-title
                  "
                  @click="info_block_vrn = !info_block_vrn"
                >
                  <i class="fa fa-question-circle"></i>
                </div>
              </h3>

              <div v-if="info_block_vrn" class="block-wrap" style="width: 100%">
                <div class="info-block">
                  <h4>
                    <i class="fa fa-question-circle"></i>
                    {{ getrans("Why do we need this information?") }}
                  </h4>
                  <p v-if="setbrandid === 'RDU'">
                    {{
                      getrans(
                        "Your license plate is required to book a car parking space as the system works with automatic Licence Plate recognition. Please note that this number can be updated later within your account."
                      )
                    }}
                  </p>
                  <p v-else>
                    {{
                      getrans(
                        "Your vehicle registration number is required to book a car parking space as the system works with automatic number plate recognition. Please note that this number can be updated later within your account. For further information please visit our FAQ."
                      )
                    }}
                  </p>
                </div>
              </div>

              <div
                v-if="setbrandid"
                class="block-wrap block-wrap-has-question-icon"
                style="width: 56%"
              >
                <div
                  class="block"
                  :class="`${
                    v$.vehicle_vrn.$errors.length
                      ? 'form-group--error error'
                      : 'tick'
                  } ${vehicle_vrn ? 'hasValue' : ''}`"
                >
                  <input
                    type="text"
                    id="vehicle_vrn"
                    v-model="vehicle_vrn"
                    @input="upperCaseVRN(vehicle_vrn)"
                  />
                  <label for="state">
                    License Plate (no spaces please)
                    <!-- {{ getrans("Vehicle Registration") }} No Spaces Please -->
                    <span class="form-mandatory">*</span>
                  </label>
                </div>
              </div>

              <!-- <div
              class="block-wrap block-wrap-question-icon"
              style="width: 10%"
              @click="info_block_vrn = !info_block_vrn"
            >
              <i class="fa fa-question-circle"></i>
            </div> -->

              <div v-if="false" class="block-wrap" style="width: 33%">
                <div class="block find-vrn-btn">
                  <button
                    class="page-content__form-btn"
                    type="button"
                    @click="findyourvrn"
                  >
                    <i
                      v-if="loading_vrn"
                      class="fas fa-circle-notch fa-spin"
                    ></i>
                    {{ getrans("Find your reg") }}
                  </button>
                </div>
              </div>

              <div v-if="false">
                <div class="block-wrap" style="width: 100%">
                  <div
                    style="margin-bottom: 8px"
                    class="block"
                    :class="`${vrn_color ? 'hasValue' : ''}`"
                  >
                    <input type="text" id="vrn_color" v-model="vrn_color" />
                    <label for="vrn_color">
                      {{ getrans("Primary Colour") }}
                    </label>
                  </div>
                </div>

                <div class="block-wrap" style="width: 100%">
                  <div
                    style="margin-bottom: 8px"
                    class="block"
                    :class="`${vrn_make ? 'hasValue' : ''}`"
                  >
                    <input type="text" id="vrn_make" v-model="vrn_make" />
                    <label for="vrn_make">
                      {{ getrans("Make") }}
                    </label>
                  </div>
                </div>
                <div class="block-wrap" style="width: 100%">
                  <div
                    style="margin-bottom: 8px"
                    class="block"
                    :class="`${vrn_model ? 'hasValue' : ''}`"
                  >
                    <input type="text" id="vrn_model" v-model="vrn_model" />
                    <label for="vrn_model">
                      {{ getrans("Model") }}
                    </label>
                  </div>
                </div>
              </div>

              <!--<div class="block-wrap" style="width: 45%">
              <div class="block" :class="`${outboundFlight ? 'hasValue' : ''}`">
                <input type="text" id="mobilenumber" v-model="outboundFlight" />
                <label for="mobilenumber">
                  {{ "Outbound Flight No." }}
                  
                </label>
              </div>
            </div>

            <div
              class="block-wrap block-wrap-has-question-icon"
              style="width: 45%"
            >
              <div class="block" :class="`${inboundFlight ? 'hasValue' : ''}`">
                <input type="text" id="mobilenumber" v-model="inboundFlight" />
                <label for="mobilenumber">
                  {{ "Inbound Flight No." }}
                  
                </label>
              </div>
            </div>

            <div
              class="block-wrap block-wrap-question-icon"
              style="width: 10%"
              @click="info_block_flight_number = !info_block_flight_number"
            >
              <i class="fa fa-question-circle"></i>
            </div>

            <div
              v-if="info_block_flight_number"
              class="block-wrap"
              style="width: 66.666666%"
            >
              <div class="info-block">
                <h4>
                  <i class="fa fa-question-circle"></i> Why are we asking for
                  this information?
                </h4>
                <p>Flight number information</p>
              </div>
            </div>-->

              <div style="clear: both"></div>
            </div>

            <!-- Fasttrack customers section -->

            <div
              class="page-content__form--box-style"
              v-if="fasttrack_cartitem && showForm"
            >
              <h3 class="page-content__form-title">
                {{ getrans("Express Lane Passengers") }}
                <div
                  class="
                    block-wrap
                    block-wrap-question-icon
                    block-wrap-question-icon--in-title
                  "
                  @click="
                    info_block_fastrack_passengers =
                      !info_block_fastrack_passengers
                  "
                >
                  <i class="fa fa-question-circle"></i>
                </div>
              </h3>

              <div
                v-if="info_block_fastrack_passengers"
                class="block-wrap"
                style="width: 100%"
              >
                <div class="info-block">
                  <h4>
                    <i class="fa fa-question-circle"></i>
                    {{ getrans("Why do we need this information?") }}
                  </h4>
                  <p>
                    {{
                      getrans(
                        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Quos id, cupiditate velit molestias, nemo doloremque cumque architecto sapiente quia deleniti dolore iste suscipit! Magni velit perspiciatis necessitatibus illo ipsam mollitia."
                      )
                    }}
                  </p>
                </div>
              </div>

              <div style="clear: both"></div>

              <!-- loop over Adults -->
              <div
                class="passenger-block"
                v-if="fasttrack_passengers_ADL.length > 0"
              >
                <template
                  v-for="(fasttrack_passenger, i) in fasttrack_passengers_ADL"
                  :key="'ADL-' + i"
                >
                  <div>
                    <span class="inputs-heading"> Adult {{ i + 1 }} </span>

                    <div class="block-wrap" style="width: 20%">
                      <div
                        class="block"
                        :class="`${
                          fasttrack_passenger.title ? 'hasValue' : ''
                        }`"
                      >
                        <select
                          class="styled_select"
                          v-model="fasttrack_passenger.title"
                        >
                          <option></option>
                          <option>{{ getrans("Mr") }}</option>
                          <option>{{ getrans("Mrs") }}</option>
                          <option>{{ getrans("Rather not say") }}</option>
                        </select>
                        <label for="title">
                          {{ getrans("Title") }}
                          <span class="form-mandatory">*</span>
                        </label>
                      </div>
                    </div>

                    <div class="block-wrap" style="width: 30%">
                      <div
                        class="block"
                        :class="`${
                          fasttrack_passenger.firstname ? 'hasValue tick' : ''
                        }`"
                      >
                        <input
                          type="text"
                          id="firstname"
                          v-model="fasttrack_passenger.firstname"
                        />
                        <label for="firstname">
                          {{ getrans("First Name") }}
                          <span class="form-mandatory">*</span>
                        </label>
                      </div>
                    </div>

                    <div class="block-wrap" style="width: 50%">
                      <div
                        class="block"
                        :class="`${
                          fasttrack_passenger.surname ? 'hasValue tick' : ''
                        }`"
                      >
                        <input
                          type="text"
                          id="lastname"
                          v-model="fasttrack_passenger.surname"
                        />
                        <label for="surname">
                          {{ getrans("Surname") }}
                          <span class="form-mandatory">*</span>
                        </label>
                      </div>
                    </div>
                  </div>
                </template>
                <div style="clear: both"></div>
              </div>

              <!-- loop over Children -->
              <div
                class="passenger-block"
                v-if="fasttrack_passengers_CHD.length > 0"
              >
                <template
                  v-for="(fasttrack_passenger, i) in fasttrack_passengers_CHD"
                  :key="'CHD-' + i"
                >
                  <div>
                    <span class="inputs-heading"> Child {{ i + 1 }} </span>

                    <div class="block-wrap" style="width: 20%">
                      <div
                        class="block"
                        :class="`${
                          fasttrack_passenger.title ? 'hasValue' : ''
                        }`"
                      >
                        <select
                          class="styled_select"
                          v-model="fasttrack_passenger.title"
                        >
                          <option></option>
                          <option>{{ getrans("Mr") }}</option>
                          <option>{{ getrans("Mrs") }}</option>
                          <option>{{ getrans("Rather not say") }}</option>
                        </select>
                        <label for="title">
                          {{ getrans("Title") }}
                          <span class="form-mandatory">*</span>
                        </label>
                      </div>
                    </div>

                    <div class="block-wrap" style="width: 30%">
                      <div
                        class="block"
                        :class="`${
                          fasttrack_passenger.firstname ? 'hasValue tick' : ''
                        }`"
                      >
                        <input
                          type="text"
                          id="firstname"
                          v-model="fasttrack_passenger.firstname"
                        />
                        <label for="firstname">
                          {{ getrans("First Name") }}
                          <span class="form-mandatory">*</span>
                        </label>
                      </div>
                    </div>

                    <div class="block-wrap" style="width: 50%">
                      <div
                        class="block"
                        :class="` ${
                          fasttrack_passenger.surname ? 'hasValue tick' : ''
                        }`"
                      >
                        <input
                          type="text"
                          id="lastname"
                          v-model="fasttrack_passenger.surname"
                        />
                        <label for="surname">
                          {{ getrans("Surname") }}
                          <span class="form-mandatory">*</span>
                        </label>
                      </div>
                    </div>
                  </div>
                </template>
                <div style="clear: both"></div>
              </div>

              <!-- loop over Infant -->

              <div
                class="passenger-block"
                v-if="fasttrack_passengers_INF.length > 0"
              >
                <template
                  v-for="(fasttrack_passenger, i) in fasttrack_passengers_INF"
                  :key="'INF-' + i"
                >
                  <div>
                    <span class="inputs-heading"> Infant {{ i + 1 }} </span>

                    <div class="block-wrap" style="width: 20%">
                      <div
                        class="block"
                        :class="`${
                          fasttrack_passenger.title ? 'hasValue' : ''
                        }`"
                      >
                        <select
                          class="styled_select"
                          v-model="fasttrack_passenger.title"
                        >
                          <option></option>
                          <option>{{ getrans("Mr") }}</option>
                          <option>{{ getrans("Mrs") }}</option>
                          <option>{{ getrans("Rather not say") }}</option>
                        </select>
                        <label for="title">
                          {{ getrans("Title") }}
                          <span class="form-mandatory">*</span>
                        </label>
                      </div>
                    </div>

                    <div class="block-wrap" style="width: 30%">
                      <div
                        class="block"
                        :class="`${
                          fasttrack_passenger.firstname ? 'hasValue tick' : ''
                        }`"
                      >
                        <input
                          type="text"
                          id="firstname"
                          v-model="fasttrack_passenger.firstname"
                        />
                        <label for="firstname">
                          {{ getrans("First Name") }}
                          <span class="form-mandatory">*</span>
                        </label>
                      </div>
                    </div>

                    <div class="block-wrap" style="width: 50%">
                      <div
                        class="block"
                        :class="`${
                          fasttrack_passenger.surname ? 'hasValue tick' : ''
                        }`"
                      >
                        <input
                          type="text"
                          id="lastname"
                          v-model="fasttrack_passenger.surname"
                        />
                        <label for="surname">
                          {{ getrans("Surname") }}
                          <span class="form-mandatory">*</span>
                        </label>
                      </div>
                    </div>
                  </div>
                </template>
                <div style="clear: both"></div>
              </div>

              <div style="clear: both"></div>
            </div>

            <!-- marketing section -->
            <template v-if="setbrandid === 'RDU'">
              <div
                class="
                  page-content__form-marketing page-content__form--box-style
                "
              >
                <h3 class="page-content__form-title">
                  {{ getrans("Terms & Conditions and Exclusive Offers") }}
                </h3>
                <div class="block-wrap" style="width: 100%">
                  <div
                    class="input-checkbox"
                    :class="`${
                      v$.term_condition.$errors.length
                        ? 'form-group--error error'
                        : ''
                    }`"
                  >
                    <input
                      class="custom-checkbox"
                      type="checkbox"
                      name="term_condition"
                      v-model="term_condition"
                      value="0"
                      id="term_condition"
                    />
                    <div
                      :class="`custom-checkbox-style ${
                        term_condition ? 'custom-checkbox-style--checked' : ''
                      }`"
                    ></div>
                    <label
                      for="term_condition_disabled"
                      style="pointer-events: all"
                    >
                      {{ getrans("* Accept ") }}
                      <a target="_blank" :href="terms_and_conditions_link">{{
                        getrans("Terms & Conditions")
                      }}</a>
                    </label>
                  </div>
                </div>
                <div class="block-wrap" style="width: 100%">
                  <div class="input-checkbox" :class="``">
                    <input
                      class="custom-checkbox"
                      type="checkbox"
                      name="email_consent"
                      v-model="email_consent"
                      value="0"
                      id="email_consent"
                    />
                    <div
                      :class="`custom-checkbox-style ${
                        email_consent ? 'custom-checkbox-style--checked' : ''
                      }`"
                    ></div>
                    <label
                      for="email_consent_disabled"
                      style="pointer-events: all"
                    >
                      {{
                        getrans(
                          "Keep me up to date with the latest offers and updates from RDU Airport."
                        )
                      }}
                    </label>
                  </div>
                </div>
                <p></p>
                <div style="clear: both"></div>
              </div>
            </template>

            <!-- marketing section -->
            <template v-if="setbrandid === 'HER'">
              <div
                class="
                  page-content__form-marketing page-content__form--box-style
                "
              >
                <h3 class="page-content__form-title">
                  {{ getrans("Terms & Conditions and Exclusive Offers") }}
                </h3>

                <div class="block-wrap" style="width: 100%">
                  <div
                    class="input-checkbox"
                    :class="`${
                      v$.term_condition.$errors.length
                        ? 'form-group--error error'
                        : ''
                    }`"
                  >
                    <input
                      class="custom-checkbox"
                      type="checkbox"
                      name="term_condition"
                      v-model="term_condition"
                      value="0"
                      id="term_condition"
                    />
                    <div
                      :class="`custom-checkbox-style ${
                        term_condition ? 'custom-checkbox-style--checked' : ''
                      }`"
                    ></div>
                    <label
                      for="term_condition_disabled"
                      style="pointer-events: all"
                    >
                      {{ getrans("I accept the Terms and Conditions") }} *
                      <a target="_blank" :href="terms_and_conditions_link">{{
                        getrans("Terms & Conditions")
                      }}</a>
                    </label>
                  </div>
                </div>

                <div class="block-wrap" style="width: 100%">
                  <div class="input-checkbox" :class="``">
                    <input
                      class="custom-checkbox"
                      type="checkbox"
                      name="email_consent"
                      v-model="email_consent"
                      value="0"
                      id="email_consent"
                    />
                    <div
                      :class="`custom-checkbox-style ${
                        email_consent ? 'custom-checkbox-style--checked' : ''
                      }`"
                    ></div>
                    <label
                      for="email_consent_disabled"
                      style="pointer-events: all"
                    >
                      <template v-if="lang.toLowerCase() === 'el'">
                        <!-- EL -->
                        Επικοινωνία, αποκλειστικές προσφορές και νέες υπηρεσίες:
                        Λάβετε επικοινωνία από τη Hermes Airports Ltd
                        συμπεριλαμβανομένων και πληροφοριών σχετικά με
                        αποκλειστικές προσφορές και καινούριες υπηρεσίες.
                        Μπορείτε να απεγγραφείτε πατώντας στο εικονίδιο
                        «Απεγγραφή» το οποίο βρίσκεται στο κάτω μέρος
                        οποιασδήποτε επικοινωνίας λαμβάνετε από εμάς μέσω
                        ηλεκτρονικού μηνύματος. Επισκεφθείτε την
                        <a target="_blank" :href="privacy_policy_link"
                          >Πολιτική Απορρήτου</a
                        >
                        για περισσότερες πληροφορίες.
                      </template>
                      <template v-else>
                        <!-- EN -->
                        {{
                          getrans(
                            "Communication, exclusive offers and new services: Receive communication from Hermes Airports Ltd including information on exclusive offers and new services. You can unsubscribe by clicking on the “unsubscribe” button which will be on the bottom of all communication you receive from us by email. Visit our Privacy Notice to learn more."
                          )
                        }}
                        <a target="_blank" :href="privacy_policy_link">{{
                          getrans("Privacy Notice")
                        }}</a>
                      </template>
                    </label>
                  </div>
                </div>

                <p></p>

                <div style="clear: both"></div>
              </div>
            </template>

            <div v-if="setbrandid" class="page-content__form-proceed">
              <button type="submit">
                <i
                  v-if="loading_proceed"
                  class="fas fa-circle-notch fa-spin"
                ></i>
                {{ getrans("Continue") }}
              </button>
            </div>
          </form>

          <div
            id="psp-form"
            class="page-content__form-marketing page-content__form--box-style"
            v-show="payform"
          >
            <form
              action="https://securepaymentdev.rezcommdev.com/nmi/process.php"
              method="post"
              @submit.prevent="pay_submit"
            >
              <table class="w-100">
                <tr>
                  <td>CC Number</td>
                  <td id="demoCcnumber"></td>
                </tr>
                <tr>
                  <td>CC Exp</td>
                  <td id="demoCcexp"></td>
                </tr>
                <tr>
                  <td>CVV</td>
                  <td id="demoCvv"></td>
                </tr>
              </table>
              <input type="hidden" name="amount" v-model="final_amount" />
              <input type="hidden" name="first_name" v-model="firstname" />
              <input type="hidden" name="last_name" v-model="surname" />
              <input type="hidden" name="address" v-model="address" />
              <input type="hidden" name="city" v-model="town" />
              <input type="hidden" name="state" v-model="state" />
              <input type="hidden" name="zip" v-model="postcode" />
              <input
                type="hidden"
                name="orderreference"
                v-model="final_orderreference"
              />
              <input
                type="hidden"
                name="transaction_token"
                v-model="transaction_token"
              />
              <input type="hidden" name="uuid" v-model="final_uuid" />
              <input type="hidden" name="brand_id" v-model="setbrandid" />
              <button
                id="demoPayButton"
                type="button"
                class="page-content__form-btn mt-3"
                @click="payform_submit"
              >
                <i class="fas fa-circle-notch fa-spin"></i>
                Complete Payment
              </button>
            </form>
          </div>

          <!-- cards here -->
          <div class="bank-cards" v-if="setbrandid != 'HER'">
            <i class="fa fa-lock"></i>
            <img src="@/assets/images/cards/visa.png" alt="user image" />
            <img src="@/assets/images/cards/mastercard.png" alt="user image" />
            <img src="@/assets/images/cards/discover.png" alt="user image" />
            <img src="@/assets/images/cards/amex.png" alt="user image" />
            <img src="@/assets/images/cards/dinersclub.png" alt="user image" />
            <img src="@/assets/images/cards/jcb.png" alt="user image" />
            <img src="@/assets/images/cards/maestro.png" alt="user image" />
          </div>
        </div>
        <div
          class="page-content__basket"
          v-if="cartloaded"
          :class="showing_basket ? '' : 'page-content__hide-section-on-mobile'"
        >
          <div
            class="
              page-content__basket-subtotal page-content__basket--box-style
            "
          >
            <span class="page-content__form-title"
              >{{ getrans("Basket Subtotal") }}:</span
            >
            <span
              class="page-content__form-title page-content__form-title--price"
              >{{ currency }}
              {{
                parseFloat(finaltotalvalue).toFixed(2) ||
                parseFloat(cartitem.price).toFixed(2)
              }}
            </span>
            <button style="width: 100%" @click="toggleBasket()">
              {{ getrans("Click to proceed") }}
            </button>
          </div>

          <BasketItem
            v-on:finaltotalvalueChange="finaltotalvalueChange"
            v-on:basketItemsNumber="basketItemsNumber"
            :prop_parking_cartitem="cartitem"
            :item_price="cartitem ? cartitem.price : undefined"
            :item_title="cartitem ? cartitem.carpark_name : undefined"
            :item_start_date="
              cartitem ? formatDatedmy(cartitem.valid_from) : undefined
            "
            :item_start_time="cartitem ? cartitem.start_time : undefined"
            :item_end_date="
              cartitem ? formatDatedmy(cartitem.valid_till) : undefined
            "
            :item_end_time="cartitem ? cartitem.end_time : undefined"
            :prop_fasttrack_cartitem="fasttrack_cartitem"
            :remove_fasttrack_cartitem="update_fasttrack_cartitem"
            :prop_lounge_cartitem="lounge_cartitem"
            :remove_lounge_cartitem="update_lounge_cartitem"
            :update_cart_items="update_cart_items"
            :lang="lang.toUpperCase()"
            :translations="translations"
            :brandSlug="brandSlug"
          />
        </div>
      </div>
      <div v-html="formdata_payform"></div>
    </div>

    <Footer
      :footer_links="footer_links"
      :footer_columns="footer_columns"
      :lang="lang.toUpperCase()"
      :translations="translations"
      :brandSlug="setbrandid"
    ></Footer>
    <!-- <LoginModel /> -->

    <Cookies :brandSlug="setbrandid" :translations="translations"/>
    <CookiesOld :brandSlug="setbrandid" v-if="setbrandid === 'RDU'"/>
  </div>
</template>

<script>
const axios = require("axios");
import Header from "../../components/Header.vue";
import Footer from "../../components/Footer.vue";
import YourDetailsBanner from "../../components/YourDetailsBanner.vue";
import BasketItem from "../../components/BasketItem.vue";
import OTPInput from "../../components/OTPInput.vue";
import Cookies from "../../components/Cookies.vue";
import CookiesOld from "../../components/Cookies_old.vue";

const genkeys = require("rezauthlib");
import Swal from "sweetalert2";
const { EncryptStorage } = require("encrypt-storage");
const encryptStorage = new EncryptStorage(process.env.VUE_APP_CHL, {
  storageType: "sessionStorage",
});
const crypto = require("crypto");
import { reactive } from "vue";

import md5 from "js-md5";
const localforage = require("localforage");
let store = localforage.createInstance({
  name: "tranlations",
});

import useVuelidate from "@vuelidate/core";
import {
  required,
  requiredIf,
  email,
  numeric,
  minLength,
  maxLength,
  alpha,
} from "@vuelidate/validators";

import { set_style_vars } from "@/modules/set_style_vars";

export default {
  name: "App",
  components: {
    Header,
    Footer,
    YourDetailsBanner,
    BasketItem,
    OTPInput,
    Cookies,
    CookiesOld,
    // ResultsList,
    // ResultsGrid,
    // SearchWidget,
  },
  data() {
    return {
      updateHeader: 0,
      finprice: 0,
      styles_loaded: false,
      otp_readonly: true,
      cpkincart: false,
      finaltotalvalue: false,
      final_amount: "",
      final_orderreference: "",
      transaction_token: "",
      final_uuid: "",
      basket_items_number: 0,
      guesttomember: "N",
      is_guest: "",
      lang: "en",
      translations: "",
      v$: useVuelidate(),
      password: "",
      emailid: "",
      emailid_wo: "",
      emailid_loading: false,
      loading_address: false,
      loading_vrn: false,
      loading_proceed: false,
      showvrnfields: false,
      vrn_color: "",
      vrn_make: "",
      vrn_model: "",
      email: "",
      email_confirm: "",
      title: "",
      firstname: "",
      surname: "",
      phonecode: "+1",
      mobilenumber: "",
      country: "EL",
      showaddressfields: true,
      address: "",
      address_line_2: "",
      town: "",
      state: "",
      postcode: "",
      billingaddress_api: [],
      vehicle_vrn: "",
      info_your_details: false,
      info_block_vrn: false,
      info_block_fastrack_passengers: false,
      outboundFlight: "",
      inboundFlight: "",
      info_block_flight_number: false,
      term_condition: false,
      email_consent: false,
      registeristrue: false,
      userexists: false,
      loginistrue: true,
      passistrue: false,
      date1_date: "",
      date1_time: "",
      date2_date: "",
      date2_time: "",
      searchres: [],
      carparkdetails: [],
      dataloaded: false,
      dataloaded_carparkdetails: false,
      widgetloaded: false,
      css_data: undefined,
      results_headline: "Official airport parking",
      results_subheadline: "11 Dec 2021 at 9:00 am - 11 Dec 2021 at 9:00 am",
      brand_data: undefined,
      brand_data_key: 0,
      brand_product_styles: reactive({}),
      brand_product_settings: {},
      brand_products: {},
      hero_desktop_background: "",
      hero_mobile_background: "",
      logo_image: "",
      hero_font_size_h1: "1.5rem",
      hero_font_size_h1_mobile: "1.3rem",
      hero_font_size_p: "1.3rem",
      hero_font_size_p_mobile: "1rem",
      hero_text_align: "center",
      hero_text_align_mobile: undefined,
      use_local_data: false,
      header_menu: [],
      footer_links: [],
      logo_link: { mtype: "Internal", url: "/" },
      home_link: undefined,
      panels_background_color: "#d6d6d6",
      panels_group: undefined,
      panel_columns: 1,
      footer_columns: "1 Columns",
      show_basket: true,
      result_selected_style: "list",
      result_selected_order: "closest",
      cartitem: {},
      cartitem_park: {},
      fasttrack_cartitem: {},
      lounge_cartitem: {},
      cartloaded: false,
      showing_basket: true,
      banner_headline: "Enter your details",
      banner_headline_mobile: "Your Booking Summary",
      proceedtologinuser_loading: false,
      formdata_payform: "",
      fasttrack_passengers_ADL: [],
      fasttrack_passengers_CHD: [],
      fasttrack_passengers_INF: [],
      fasttrack_tot_passengers: [],
      showForm: false,
      setbrandid: "",
      currency: "",
      payform: false,
      goto_page_url: "/results.html",

      privacy_policy_link: "",
      faqs_link: "",
      my_account_link: "",
      terms_and_conditions_link: "",
    };
  },
  validations() {
    if (this.setbrandid === "RDU") {
      return {
        password: { required, minLength: minLength(6) },
        emailid: { required, email },
        emailid_wo: { required, email },
        firstname: { required, alpha, minLength: minLength(2) },
        surname: { required, alpha, minLength: minLength(2) },
        email: { required, email },
        email_confirm: { required, email },
        phonecode: { required },
        title: { required },
        mobilenumber: {
          required,
          numeric,
          minLength: minLength(7),
          maxLength: maxLength(15),
        },
        address: { required },
        postcode: { required },
        town: { required },
        state: { required },
        vehicle_vrn: { required: requiredIf(this.checkpowerfields) },
        term_condition: {
          required(val) {
            return val;
          },
        },
      };
    } else if (this.setbrandid === "HER") {
      return {
        password: { required, minLength: minLength(6) },
        emailid: { required, email },
        emailid_wo: { required, email },
        firstname: { required, alpha, minLength: minLength(2) },
        surname: { required, alpha, minLength: minLength(2) },
        email: { required, email },
        email_confirm: { required, email },
        phonecode: { required },
        title: { required },
        mobilenumber: {
          required,
          numeric,
          minLength: minLength(7),
          maxLength: maxLength(15),
        },
        // address: { required },
        postcode: { required },
        town: { required },
        vehicle_vrn: { required: requiredIf(this.checkpowerfields) },
        term_condition: {
          required(val) {
            return val;
          },
        },
      };
    } else {
      return {};
    }
  },
  computed: {
    new_style_variables() {
      return set_style_vars(this.brand_product_styles, "yourdetails");
    },
    set_style_variables: function () {
      return {
        "--hero-background-mobile": `url(${this.hero_desktop_background})`,
        "--hero-background-desktop": this.hero_mobile_background
          ? `url(${this.hero_mobile_background})`
          : `url(${this.hero_desktop_background})`,
        "--hero-font-size-h1": this.hero_font_size_h1,
        "--hero-font-size-h1-mobile": this.hero_font_size_h1_mobile,
        "--hero-font-size-p": this.hero_font_size_p,
        "--hero-font-size-p-mobile": this.hero_font_size_p_mobile,
        "--hero-text-align": this.hero_text_align,
        "--hero-text-align-mobile":
          this.hero_text_align_mobile || this.hero_text_align,
        "--panel-background-color": this.panels_background_color,
      };
    },
  },
  methods: {
    payform_submit() {
      document.getElementById("app").classList.add("submit_click");
    },
    update_fasttrack_cartitem() {
      this.fasttrack_cartitem = encryptStorage.getItem("fasttrack_cart");
    },
    update_lounge_cartitem() {
      this.lounge_cartitem = encryptStorage.getItem("lounge_cart");
    },
    update_cart_items() {
      this.cartitem = encryptStorage.getItem("cart");
      this.updateHeader++;
    },
    checkHomeRedirect() {
      if (
        !encryptStorage.getItem("fasttrack_cart") &&
        !encryptStorage.getItem("lounge_cart") &&
        !encryptStorage.getItem("cart")
      ) {
        window.location.href = "/index.html";
      }
    },
    checkHomeRedirectCartTimeout() {
      var noww = new Date().getTime();
      var snddc = encryptStorage.getItem("snddc");
      if (!snddc) {
        encryptStorage.setItem("snddc", noww);
        //sessionStorage.clear();
        window.location.href = "/index.html";
      } else {
        if (noww - snddc > 60 * 60 * 1000) {
          //sessionStorage.clear();
          window.location.href = "/index.html";
        }
      }
    },
    checkpowerfields() {
      if (typeof this.cartitem !== "undefined") {
        //console.log("aaaaa");
        return true;
      } else {
        return false;
      }
    },
    rectImage() {
      return `background-image: url(${require(`@/assets/images/faster_option.svg`)});`;
    },

    opt_change(value) {
      //console.log(value);
      this.password = value;
    },

    finaltotalvalueChange(value) {
      this.finaltotalvalue = value;
    },

    basketItemsNumber(value) {
      this.basket_items_number = value;
    },

    getrans(string) {
      var s = md5(string);
      var ss = this.setbrandid + "-" + this.lang.toUpperCase() + "-" + s;
      //console.log(ss);

      // console.log('----------------------');
      // console.log(string);
      // console.log(this.translations[ss]);
      // console.log(ss);
      // console.log('----------------------');

      return this.translations[ss] || string;
    },
    getSessionData(name) {
      return JSON.parse(sessionStorage.getItem(name));
    },
    setSessionData(name, value) {
      if (value != null) sessionStorage.setItem(name, JSON.stringify(value));
      else sessionStorage.removeItem(name);
    },
    loadTranslations() {
      let vm = this;
      if (vm.getSessionData("language")) {
        vm.lang = vm.getSessionData("language");
      } else {
        if (process.env.VUE_APP_DEFAULT_LANG_DE && JSON.parse(process.env.VUE_APP_DEFAULT_LANG_DE).includes(this.setbrandid)) {
          vm.lang = 'de';
        }
        vm.setSessionData("language", vm.lang);
      }

      // console.log(vm.getSessionData("language"));
      //console.log("vm.lang");

      //console.log(this.lang);

      const urlParams = new URLSearchParams(window.location.search);
      let param_lang = urlParams.get("lang");
      if (param_lang) {
        vm.lang = param_lang;
        vm.setSessionData("language", vm.lang);
      }

      store.getItem("tranlations").then((params) => {
        if (params !== null) {
          vm.translations = JSON.parse(params);
          //console.log("getTranscache");
          //console.log(vm.translations);
        } else {
          axios
            .get(
              "https://devhub.rezcomm.com/hubapmydbauth/brandapi/devtrans.php?brandslug=" +
                vm.setbrandid
            )
            .then((response) => {
              //console.log("getTranscache");
              // console.log(response);
              vm.translations = JSON.parse(response.request.response);
              store.setItem("tranlations", JSON.stringify(vm.translations));
            });
        }
      });
    },

    toggleBasket() {
      //console.log("toggle basket");
      this.showing_basket = !this.showing_basket;
      console.log(this.showing_basket);
      if (this.showing_basket) {
        this.banner_headline_mobile = "Booking Summary";
      } else {
        this.banner_headline_mobile = "Enter your details";
      }
    },

    formatDatedmy(date) {
      if (typeof date !== "undefined") {
        date = date.split("/");
        date = date[2] + "/" + date[1] + "/" + date[0];
        return date;
      } else {
        return "";
      }
    },
    populateaddress(event) {
      let optionText = event.target.value;
      let postcode_search_ar = optionText.split("~");
      this.address = postcode_search_ar[0];
      this.address_line_2 = postcode_search_ar[1];
      this.town = postcode_search_ar[2];
      this.state = postcode_search_ar[3];
      this.showaddressfields = true;
      this.billingaddress_api = "";
    },
    selectcountry() {
      let coun = this.country;
      if (coun != "GB" && coun != "") {
        this.showaddressfields = true;
      } else {
        this.showaddressfields = false;
      }
    },
    findyouraddress() {
      this.loading_address = true;
      let postcode = this.postcode;
      this.showaddressfields = false;
      this.showaddressfields_manually = false;
      this.billingaddress_api = [];
      if (postcode == "") {
        Swal.fire("Error!", "Please enter postcode", "error");
        this.loading_address = false;
      } else {
        this.findingAddress = true;
        let datasearch = { postcode: postcode };
        axios
          .post(encryptStorage.getItem("rez_dev_k").VUE_APP_DOMAIN_LIVESSO + "pcodeaddr/", datasearch, {
            headers: {
              secretid: "38eb6e4255600abb3e09a1b19a2df9a4",
              secretkey: "5c57a045451d59c080c27be1225733f26fe97b614f581120",
            },
          })
          .then(
            (response) => {
              this.emailid_loading = false;
              let datasent = JSON.parse(response.request.response);
              if (datasent.message) {
                this.loading_address = false;
                Swal.fire({
                  title: "Sorry",
                  html: "We could not find the address details.",
                  showCancelButton: true,
                  confirmButtonText: `Enter Manually`,
                }).then((result) => {
                  if (result.isConfirmed) {
                    this.showaddressfields = !this.showaddressfields;
                    this.showfindaddress = false;
                  }
                });
              } else {
                if (datasent.length == 0) {
                  this.loading_address = false;
                  Swal.fire({
                    title: "Sorry",
                    html: "We could not find the address details.",
                    showCancelButton: true,
                    confirmButtonText: `Enter Manually`,
                  }).then((result) => {
                    if (result.isConfirmed) {
                      this.showaddressfields = !this.showaddressfields;
                      this.showfindaddress = false;
                    }
                  });
                } else {
                  this.loading_address = false;
                  console.log("datasent", datasent);
                  this.billingaddress_api = datasent;
                  // console.log("billingaddress_api", this.billingaddress_api);
                  this.showaddressfields_manually = false;
                }
              }
              this.findingAddress = false;
              this.loading_address = false;
            },
            (error) => {
              console.log(error);
              this.findingAddress = false;
              this.loading_address = false;
            }
          );
      }
    },
    upperCaseVRN(newValue) {
      if (!newValue) return;
      this.vehicle_vrn = newValue.toString().toUpperCase();
      this.vehicle_vrn = this.vehicle_vrn.replaceAll(" ", "");
    },
    lowerCaseEmail(newValue) {
      this.email = newValue.toLowerCase();
    },
    lowerCaseEmail_Confirm(newValue) {
      this.email_confirm = newValue.toLowerCase();
    },
    setListStyle(type) {
      this.result_selected_style = type;
    },
    setListOrder(type) {
      this.result_selected_order = type;
    },
    getLocalData(name) {
      return JSON.parse(sessionStorage.getItem(name));
    },
    setLocalData(name, value) {
      if (value != null) sessionStorage.setItem(name, JSON.stringify(value));
      else sessionStorage.removeItem(name);
    },
    setBrandData() {
      this.brand_data = this.getLocalData("brand_data");
      this.setStyles(this.brand_data.brand_product_styles);
      this.brand_product_settings = this.brand_data.brand_product_settings;
      this.brand_products = this.brand_data.brand_products;
      this.brand_data_key++;
      this.styles_loaded = true;

      if (this.setbrandid === "RDU") {
        if (this.lang.toLowerCase() === "en") {
          this.privacy_policy_link = "https://www.rdu.com/privacy/";
          this.faqs_link = "https://www.rdu.com/parking/parking-faq/";
          this.my_account_link = "https://rduv6myaccountdev.rezcommdev.com/";
          this.terms_and_conditions_link =
            "https://rduv6devcombined.rezcommdev.com/terms.html";
        }
      }

      if (this.setbrandid === "HER") {
        if (this.lang.toLowerCase() === "en") {
          this.privacy_policy_link =
            "https://www.hermesairports.com/privacy-notice";
          this.faqs_link =
            "https://www.hermesairports.com/prepare-your-journey/fly-out/access--parking/assistance";
          this.my_account_link = "https://myaccount.hermesairports.com/";
          this.terms_and_conditions_link =
            "https://www.hermesairports.com/terms-and-conditions-of-use";
        } else if (this.lang.toLowerCase() === "el") {
          this.privacy_policy_link =
            "https://el.hermesairports.com/privacy-notice";
          this.faqs_link =
            "https://www.hermesairports.com/prepare-your-journey/fly-out/access--parking/assistance";
          this.my_account_link = "https://myaccount.hermesairports.com/";
          this.terms_and_conditions_link =
            "https://el.hermesairports.com/terms-and-conditions-of-use";
        }
      }
    },
    getBrandData() {
      if (this.use_local_data && this.getLocalData("brand_data")) {
        this.setBrandData();
      } else {
        let secsa = genkeys(
          encryptStorage.getItem("rez_dev_k").VUE_APP_BRNDDET_SECRETID,
          encryptStorage.getItem("rez_dev_k").VUE_APP_BRNDDET_SECRETKEY
        );
        let b1s = secsa.b1s;
        let v2s = secsa.v2s;
        let a1 = secsa.a1;
        let v1 = secsa.v1;
        let c2s = secsa.c2s;
        let uidgen = secsa.uidgen;
        //console.log("uidgen", uidgen);

        axios
          .post(
            encryptStorage.getItem("rez_dev_k").VUE_APP_DOMAIN_DEVHUB +
              "hubapmydbauth/brandapi/branddetailslive.php?brandslug=" +
              this.setbrandid,
            "",
            {
              headers: {
                b1: b1s,
                v2: v2s,
                c2s: c2s,
                a1: a1,
                v1: v1,
                c1: uidgen,
                "Content-Type": "application/json",
              },
            }
          )
          .then((response) => {
            //console.log(response.data);
            this.setLocalData("brand_data", response.data);
            this.setMenu(response.data);
            this.createPanels(response.data);
            this.setBrandData();
          });
      }
    },

    setStyles(obj) {
      /* eslint-disable */
      obj.forEach((item) => {
        for (const [classname, style] of Object.entries(item)) {
          this.brand_product_styles[classname] = style;
        }
      });
      //console.log(this.brand_product_styles["asset_image_1"]);
      this.logo_image = this.brand_product_styles["asset_image_1"];
      this.hero_font_size_h1 =
        this.brand_product_styles["panel_heading_font_size"];
      this.hero_font_size_h1_mobile =
        this.brand_product_styles["panel_heading_font_size"];
      this.hero_font_size_p = this.brand_product_styles["panel_text_font_size"];
      this.hero_font_size_p_mobile =
        this.brand_product_styles["panel_text_font_size"];
      /* eslint-enable */
    },
    setMenu(data) {
      data.brand_menu.forEach((menu) => {
        if (menu.label.toLowerCase() === "home") {
          this.home_link = menu.url;
        }
        if (menu.label.toLowerCase() === "logo") {
          this.logo_link = menu;
        }
        menu.loggedin = true;
        menu.loggedout = true;
      });

      const top_menu = data.brand_menu.filter((menu) => menu.position === "T");
      this.createHeaderLinks(top_menu);

      const footer_menu = data.brand_menu.filter(
        (menu) => menu.position === "B"
      );
      this.createFooterLinks(footer_menu);
    },
    createHeaderLinks(data) {
      const header_menu = [];
      if (data.length > 0) {
        data.forEach((menu) => {
          if (menu.label.toLowerCase() === "basket") {
            this.show_basket = true;
          } else if (
            menu.label.toLowerCase() !== "home" &&
            menu.label.toLowerCase() !== "logo"
          ) {
            header_menu.push(menu);
          }
        });
      }
      this.header_menu = header_menu;
    },
    createFooterLinks(data) {
      this.footer_columns = data[0].mcolumn;
      this.footer_links = data.reduce((a, r) => {
        if (!a[r.mgroup]) a[r.mgroup] = { group: r.mgroup, data: [] };
        a[r.mgroup].data.push(r);
        return a;
      }, {});
    },
    createPanels(data) {
      let panels_data = data.brand_home_panels || [];
      panels_data.sort((a, b) => (a.rownum > b.rownum ? 1 : -1));
      panels_data = panels_data.reduce((a, r) => {
        if (!a[r.rownum]) a[r.rownum] = { row: r.rownum, columns: [] };
        a[r.rownum].columns.push(r);
        return a;
      }, {});
      this.panels_group = panels_data;
    },
    correctdate(d) {
      d = d.replace("st", "");
      d = d.replace("nd", "");
      d = d.replace("rd", "");
      d = d.replace("th", "");
      return d;
    },
    formatDateymd(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();
      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      return [year, month, day].join("/");
    },
    continueasguest_action() {
      this.continueasguest = false;
      this.registeristrue = true;
      this.passistrue = false;
      this.EmailConfirm = "";
      this.updateHeader += 1;
    },
    ValidateEmail(mail) {
      var mailformat = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,6})+$/;
      if (mail.match(mailformat)) {
        return true;
      }
      return false;
    },
    genHash(str) {
      var hash = 0,
        i,
        chr;
      if (str.length === 0) return hash;
      for (i = 0; i < str.length; i++) {
        chr = str.charCodeAt(i);
        hash = (hash << 5) - hash + chr;
        hash |= 0;
      }
      return hash;
    },
    async proceedtocheckuser() {
      this.emailid_loading = true;
      if (this.emailid == "") {
        Swal.fire({
          title: "Alert",
          icon: "error",
          text: "Please enter a valid email id.",
          confirmButtonText: "Close",
          showCloseButton: true,
        });
        this.emailid_loading = false;
      } else {
        if (!this.ValidateEmail(this.emailid)) {
          Swal.fire({
            title: "Alert",
            icon: "error",
            text: "Please enter a valid email id.",
            confirmButtonText: "Close",
            showCloseButton: true,
          });
          this.emailid_loading = false;
        } else {
          let emailentered = this.emailid;
          this.submitStatuscheckemail = "PENDING";
          let datasearch = {
            brand_id: this.setbrandid,
            email_id: emailentered,
          };
          let secsa = {};
          if (this.setbrandid == "HER") {
            secsa = genkeys(
              encryptStorage.getItem("rez_dev_k").VUE_APP_VERIFYEMAIL_SID_FRA,
              encryptStorage.getItem("rez_dev_k").VUE_APP_VERIFYEMAIL_SKEY_FRA
            );
          } else {
            secsa = genkeys(
              encryptStorage.getItem("rez_dev_k").VUE_APP_VERIFYEMAIL_SID,
              encryptStorage.getItem("rez_dev_k").VUE_APP_VERIFYEMAIL_SKEY
            );
          }
          let b1s = secsa.b1s;
          let v2s = secsa.v2s;
          let a1 = secsa.a1;
          let v1 = secsa.v1;
          let c2s = secsa.c2s;
          let uidgen = secsa.uidgen;
          let ur = "";
          if (this.setbrandid == "HER") {
            ur =
              encryptStorage.getItem("rez_dev_k").VUE_APP_DOMAIN_DEVAWS_FRA +
              "sso/frontend/email/verify/exist";
          } else {
            ur =
              encryptStorage.getItem("rez_dev_k").VUE_APP_DOMAIN_DEVAWS +
              "sso/frontend/email/verify/exist";
          }
          axios
            .post(ur, datasearch, {
              headers: {
                b1: b1s,
                v2: v2s,
                c2s: c2s,
                a1: a1,
                v1: v1,
                c1: uidgen,
              },
            })
            .then(
              (response) => {
                this.emailid_loading = false;
                let datasent = JSON.parse(response.request.response);
                //console.log(datasent.code.toString());
                if (typeof datasent.code === "undefined") {
                  this.registeristrue = false;
                  this.loginistrue = false;
                  this.passistrue = false;
                  this.password = "";
                  this.continueasguest_action();
                  this.email_confirm = emailentered;
                  this.email = emailentered;
                  this.emailid_loading = false;
                  this.is_guest = "N";
                } else {
                  //console.log(datasent.code.toString());
                  if (datasent.code.toString() === "37") {
                    if (datasent.data.next_action == "deny") {
                      Swal.fire({
                        title: "Alert",
                        icon: "error",
                        text: datasent.data.msg,
                        confirmButtonText: "Close",
                        showCloseButton: true,
                      });
                    } else {
                      this.registeristrue = false;
                      this.loginistrue = false;
                      this.passistrue = false;
                      this.password = "000000";
                      this.continueasguest_action();
                    }
                    this.email_confirm = emailentered;
                    this.email = emailentered;
                    this.is_guest = "N";
                  } else {
                    if (datasent.code.toString() == "1") {
                      this.passwordless = true;
                      let is_guest_db = datasent.msg.is_guest;
                      this.is_guest = is_guest_db;
                      if (is_guest_db == "Y") {
                        this.registeristrue = false;
                        this.loginistrue = false;
                        this.passistrue = false;
                        this.password = "000000";
                        this.continueasguest_action();
                        this.email_confirm = emailentered;
                        this.email = emailentered;
                        this.is_guest = "N";
                        this.guesttomember = "Y";
                      } else {
                        let datatogenotp = {
                          brand_id: this.setbrandid,
                          email_id: emailentered,
                        };
                        let secotp = {};
                        if (this.setbrandid == "HER") {
                          secotp = genkeys(
                            encryptStorage.getItem("rez_dev_k").VUE_APP_OTP_SECRETID_FRA,
                            encryptStorage.getItem("rez_dev_k").VUE_APP_OTP_SECRETKEY_FRA
                          );
                        } else {
                          secotp = genkeys(
                            encryptStorage.getItem("rez_dev_k").VUE_APP_OTP_SECRETID,
                            encryptStorage.getItem("rez_dev_k").VUE_APP_OTP_SECRETKEY
                          );
                        }
                        let b1o = secotp.b1s;
                        let v2o = secotp.v2s;
                        let a1o = secotp.a1;
                        let v1o = secotp.v1;
                        let c2o = secotp.c2s;
                        let uidgeno = secotp.uidgen;
                        let ur = "";
                        if (this.setbrandid == "HER") {
                          ur =
                            encryptStorage.getItem("rez_dev_k").VUE_APP_DOMAIN_DEVAWS_FRA +
                            "sso/frontend/email/login/otp/send";
                        } else {
                          ur =
                            encryptStorage.getItem("rez_dev_k").VUE_APP_DOMAIN_DEVAWS +
                            "sso/frontend/email/login/otp/send";
                        }
                        axios
                          .post(ur, datatogenotp, {
                            headers: {
                              b1: b1o,
                              v2: v2o,
                              c2s: c2o,
                              a1: a1o,
                              v1: v1o,
                              c1: uidgeno,
                            },
                          })
                          .then((response) => {
                            console.log(response);
                            this.registeristrue = false;
                            this.loginistrue = false;
                            this.passistrue = true;
                            this.password = "";
                            this.email_confirm = emailentered;
                            this.emailid_loading = false;
                            this.is_guest = "N";
                          });
                      }
                    }
                  }
                }
              },
              (error) => {
                console.log(error);
                this.emailid_loading = false;
              }
            );
        }
      }
    },
    async proceedtocheckuser_withoutotp() {
      this.emailid_loading = true;
      if (this.emailid_wo == "") {
        Swal.fire({
          title: "Alert",
          icon: "error",
          text: "Please enter a valid email id.",
          confirmButtonText: "Close",
          showCloseButton: true,
        });
        this.emailid_loading = false;
      } else {
        if (!this.ValidateEmail(this.emailid_wo)) {
          Swal.fire({
            title: "Alert",
            icon: "error",
            text: "Please enter a valid email id.",
            confirmButtonText: "Close",
            showCloseButton: true,
          });
          this.emailid_loading = false;
        } else {
          let emailentered = this.emailid_wo;
          this.submitStatuscheckemail = "PENDING";
          let datasearch = {
            brand_id: this.setbrandid,
            email_id: emailentered,
          };
          let secsa = {};
          if (this.setbrandid == "HER") {
            secsa = genkeys(
              encryptStorage.getItem("rez_dev_k").VUE_APP_VERIFYEMAIL_SID_FRA,
              encryptStorage.getItem("rez_dev_k").VUE_APP_VERIFYEMAIL_SKEY_FRA
            );
          } else {
            secsa = genkeys(
              encryptStorage.getItem("rez_dev_k").VUE_APP_VERIFYEMAIL_SID,
              encryptStorage.getItem("rez_dev_k").VUE_APP_VERIFYEMAIL_SKEY
            );
          }
          let b1s = secsa.b1s;
          let v2s = secsa.v2s;
          let a1 = secsa.a1;
          let v1 = secsa.v1;
          let c2s = secsa.c2s;
          let uidgen = secsa.uidgen;
          let ur = "";
          if (this.setbrandid == "HER") {
            ur =
              encryptStorage.getItem("rez_dev_k").VUE_APP_DOMAIN_DEVAWS_FRA +
              "sso/frontend/email/verify/exist";
          } else {
            ur =
              encryptStorage.getItem("rez_dev_k").VUE_APP_DOMAIN_DEVAWS +
              "sso/frontend/email/verify/exist";
          }
          axios
            .post(ur, datasearch, {
              headers: {
                b1: b1s,
                v2: v2s,
                c2s: c2s,
                a1: a1,
                v1: v1,
                c1: uidgen,
              },
            })
            .then(
              (response) => {
                this.emailid_loading = false;
                let datasent = JSON.parse(response.request.response);

                if (typeof datasent.code === "undefined") {
                  this.registeristrue = false;
                  this.loginistrue = false;
                  this.passistrue = false;
                  this.password = "";
                  this.continueasguest_action();
                  this.email_confirm = emailentered;
                  this.email = emailentered;
                  this.emailid_loading = false;
                  this.is_guest = "Y";
                } else {
                  if (datasent.code.toString() == "37") {
                    if (datasent.data.next_action == "deny") {
                      Swal.fire({
                        title: "Alert",
                        icon: "error",
                        text: datasent.data.msg,
                        confirmButtonText: "Close",
                        showCloseButton: true,
                      });
                    } else {
                      this.registeristrue = false;
                      this.loginistrue = false;
                      this.passistrue = false;
                      this.password = "000000";
                      this.continueasguest_action();
                    }
                    this.email_confirm = emailentered;
                    this.email = emailentered;
                    this.is_guest = "Y";
                  } else {
                    if (datasent.code.toString() == "1") {
                      let is_guest_db = datasent.msg.is_guest;
                      this.is_guest = is_guest_db;
                      if (is_guest_db == "Y") {
                        this.registeristrue = false;
                        this.loginistrue = false;
                        this.passistrue = false;
                        this.password = "000000";
                        this.continueasguest_action();
                        this.email_confirm = emailentered;
                        this.email = emailentered;
                        this.emailid_loading = false;
                      } else {
                        Swal.fire(
                          "Error!",
                          "You seem to already have an account with us. Please use account checkout to proceed",
                          "error"
                        );
                        this.emailid_loading = false;
                        this.emailid = "";
                      }
                    }
                  }
                }
              },
              (error) => {
                console.log(error);
                this.emailid_loading = false;
              }
            );
        }
      }
    },
    getLocalDataoo(name) {
      return sessionStorage.getItem(name);
    },
    submit() {
      console.log("submit()");

      this.loading_proceed = true;

      /*  var hours = 1 / 2;
      var noww = new Date().getTime();
      var snddc = sessionStorage.getItem("snddc");

      if (snddc == null) {
        window.location.href = "/index.html";
      } else {
        let timepast = noww - snddc;
        //console.log("timepast", timepast);
        if (timepast > hours * 60 * 60 * 1000) {
          //sessionStorage.clear();
          window.location.href = "/index.html";
        }
      }
		*/
      let er = 0;
      if (this.emailid == "") {
        this.emailid = this.emailid_wo;
      }
      if (this.emailid_wo == "") {
        this.emailid_wo = this.emailid;
      }
      encryptStorage.setItem("tag_email", this.email);
      if (typeof this.fasttrack_cartitem !== "undefined") {
        this.fasttrack_tot_passengers.push(this.fasttrack_passengers_ADL);
        this.fasttrack_tot_passengers.push(this.fasttrack_passengers_CHD);
        this.fasttrack_tot_passengers.push(this.fasttrack_passengers_INF);
      }
      this.v$.$validate();
      //console.log(this.v$.$errors);
      //console.log(this.v$.$validate());

      //console.log("fasttrack_tot_passengers", this.fasttrack_tot_passengers);
      //er = 10;
      if (this.v$.$error || er > 0) {
        this.checkingOut = false;
        this.loading_proceed = false;
      }
      let fintotvalue = 0;

      console.log("this.v$.$errors", this.v$.$errors);
      console.log("er", er);

      if (!this.v$.$error && er == 0) {
        /*parking*/
        let secsaaip = genkeys(
          encryptStorage.getItem("rez_dev_k").VUE_APP_SQSCPKREG_SECRETID,
          encryptStorage.getItem("rez_dev_k").VUE_APP_SQSCPKREG_SECRETKEY
        );
        let b1saip = secsaaip.b1s;
        let v2saip = secsaaip.v2s;
        let a1aip = secsaaip.a1;
        let v1aip = secsaaip.v1;
        let c2saip = secsaaip.c2s;
        let uidgenaip = secsaaip.uidgen;

        if (typeof this.cartitem_park !== "undefined") {
          this.cpkincart = true;
          let myFormsettings = document.getElementById("payment-process");
          let formData = new FormData(myFormsettings);
          formData.append("title", this.title);
          formData.append("first_name", encodeURIComponent(this.firstname));
          formData.append("last_name", encodeURIComponent(this.surname));
          formData.append("mobilenumber", this.mobilenumber);
          formData.append("email", this.email);
          formData.append("phonecode", this.phonecode);
          formData.append("post_code", encodeURIComponent(this.postcode));
          formData.append("address_line_1", encodeURIComponent(this.address));
          formData.append(
            "address_line_2",
            encodeURIComponent(this.address_line_2)
          );
          formData.append("city", encodeURIComponent(this.town));
          formData.append("state", encodeURIComponent(this.state));
          formData.append("vehicle_vrn", encodeURIComponent(this.vehicle_vrn));
          formData.append(
            "term_condition",
            encodeURIComponent(this.term_condition)
          );
          formData.append("vrn_color", encodeURIComponent(this.vrn_color));
          formData.append("vrn_make", encodeURIComponent(this.vrn_make));
          formData.append("vrn_model", encodeURIComponent(this.vrn_model));
          formData.append(
            "cart",
            JSON.stringify(encryptStorage.getItem("cart"))
          );
          formData.append("outboundFlight", this.outboundFlight);
          formData.append("inboundFlight", this.inboundFlight);
          this.setLocalData("tag_title", this.title);
          this.setLocalData("tag_firstname", this.firstname);
          this.setLocalData("tag_surname", this.surname);
          this.setLocalData("tag_mobilenumber", this.mobilenumber);
          this.setLocalData("tag_email", this.email);
          this.setLocalData("tag_phonecode", this.phonecode);
          this.setLocalData("tag_postcode", this.postcode);
          this.setLocalData("tag_address", this.address);
          this.setLocalData("tag_address_line_2", this.address_line_2);
          this.setLocalData("tag_town", this.town);
          this.setLocalData("tag_state", this.state);
          this.setLocalData("tag_vehicle_vrn", this.vehicle_vrn);
          this.setLocalData("tag_vrn_color", this.vrn_color);
          this.setLocalData("tag_vrn_make", this.vrn_make);
          this.setLocalData("tag_vrn_model", this.vrn_model);
          this.setLocalData("tag_outboundFlight", this.outboundFlight);
          this.setLocalData("tag_inboundFlight", this.inboundFlight);
          formData.append("orderstatus", "Pending");
          formData.append("paymentstatus", "Pending");
          let totalfee = 0;
          if (this.getLocalDataoo("discount_amount") === null) {
            formData.append(
              "ordertotal",
              encryptStorage.getItem("tag_totcost")
            );
            totalfee = encryptStorage.getItem("tag_totcost");
            formData.append("discount_amount", "0.00");
            formData.append("voucher", "");
          } else {
            let discount_amount = encryptStorage.getItem("discount_amount");
            let discount_coupon_applied = encryptStorage.getItem(
              "discount_coupon_applied"
            );
            //console.log("discount_coupon_applied", discount_coupon_applied);
            //console.log("discount_amount", discount_amount);
            discount_amount = parseFloat(discount_amount);
            //console.log("discount_amount", discount_amount);
            let tag_totcost = encryptStorage.getItem("tag_totcost");
            totalfee = this.finaltotalvalue;
            totalfee = parseFloat(totalfee);
            if (totalfee < 0) {
              totalfee = 0;
            }
            //console.log("totalfee cpk", totalfee);
            this.setLocalData("tag_totcost", tag_totcost);
            formData.append("ordertotal", totalfee);
            formData.append("discount_amount", discount_amount);
            formData.append("voucher", discount_coupon_applied);
          }
          fintotvalue = fintotvalue + parseFloat(totalfee);
          encryptStorage.setItem("final_amount_paid", fintotvalue);
          console.log("fintotvalue cpk", fintotvalue);
          formData.append("uuid", this.getLocalData("uuid"));
          formData.append(
            "orderreference",
            encryptStorage.getItem("order_ref")
          );

          formData.append("email_consent", this.email_consent);
          formData.append(
            "orderreference_wtpre",
            encryptStorage.getItem("orefwithoutprefix")
          );
          formData.append("slug", this.setbrandid);
          formData.append("product", "CPK");
          formData.append("login_type", "SE");
          formData.append("is_guest", this.is_guest);
          formData.append("guesttomember", this.guesttomember);
          encryptStorage.setItem("is_guest", this.is_guest);
          encryptStorage.setItem("guesttomember", this.guesttomember);
          formData.append("country", this.country);

          var object = {};
          formData.forEach(function (value, key) {
            object[key] = value;
          });
          var jsona = JSON.stringify(object);

          axios.post(
            "https://api-frankfurt.rezcomm.com/orderlogs/prepayment",
            jsona,
            {
              headers: {
                b1: b1saip,
                v2: v2saip,
                c2s: c2saip,
                a1: a1aip,
                v1: v1aip,
                c1: uidgenaip,
              },
            }
          );
          axios
            .post(
              encryptStorage.getItem("rez_dev_k").VUE_APP_DOMAIN_DEVHUB +
                "hubapmydbauth/sqsregister/livesqs_carparking.php",
              formData,
              {
                headers: {
                  "Content-Type": "multipart/form-data",
                  b1: b1saip,
                  v2: v2saip,
                  c2s: c2saip,
                  a1: a1aip,
                  v1: v1aip,
                  c1: uidgenaip,
                },
              }
            )
            .then((response) => {
              console.log(response);
            });
        }

        var thing = this;
        if (typeof this.fasttrack_cartitem !== "undefined") {
          setTimeout(function () {
            let myFormsettings_fast =
              document.getElementById("payment-process");
            let formData_fast = new FormData(myFormsettings_fast);
            formData_fast.append("title", thing.title);
            formData_fast.append(
              "first_name",
              encodeURIComponent(thing.firstname)
            );
            formData_fast.append(
              "last_name",
              encodeURIComponent(thing.surname)
            );
            formData_fast.append("mobilenumber", thing.mobilenumber);
            formData_fast.append(
              "fasttrack_tot_passengers",
              JSON.stringify(thing.fasttrack_tot_passengers)
            );
            formData_fast.append("email", thing.email);
            formData_fast.append("phonecode", thing.phonecode);
            formData_fast.append(
              "post_code",
              encodeURIComponent(thing.postcode)
            );
            formData_fast.append(
              "address_line_1",
              encodeURIComponent(thing.address)
            );
            formData_fast.append(
              "address_line_2",
              encodeURIComponent(thing.address_line_2)
            );
            formData_fast.append("city", encodeURIComponent(thing.town));
            formData_fast.append("state", encodeURIComponent(thing.state));
            formData_fast.append(
              "vehicle_vrn",
              encodeURIComponent(thing.vehicle_vrn)
            );
            formData_fast.append(
              "term_condition",
              encodeURIComponent(thing.term_condition)
            );
            formData_fast.append(
              "vrn_color",
              encodeURIComponent(thing.vrn_color)
            );
            formData_fast.append(
              "vrn_make",
              encodeURIComponent(thing.vrn_make)
            );
            formData_fast.append(
              "vrn_model",
              encodeURIComponent(thing.vrn_model)
            );
            formData_fast.append(
              "cart",
              JSON.stringify(encryptStorage.getItem("fasttrack_cart"))
            );
            formData_fast.append("outboundFlight", thing.outboundFlight);
            formData_fast.append("inboundFlight", thing.inboundFlight);

            formData_fast.append("orderstatus", "Pending");
            formData_fast.append("paymentstatus", "Pending");
            let totalfee = 0;
            if (thing.getLocalDataoo("discount_amount") === null) {
              formData_fast.append(
                "ordertotal",
                thing.fasttrack_cartitem.fasttracksubtotal
              );
              totalfee = thing.fasttrack_cartitem.fasttracksubtotal;
              formData_fast.append("discount_amount", "0.00");
              formData_fast.append("voucher", "");
            } else {
              let discount_amount = encryptStorage.getItem("discount_amount");
              let discount_coupon_applied = encryptStorage.getItem(
                "discount_coupon_applied"
              );
              console.log("discount_coupon_applied", discount_coupon_applied);
              console.log("discount_amount", discount_amount);
              discount_amount = parseFloat(discount_amount);
              console.log("discount_amount", discount_amount);
              totalfee = thing.fasttrack_cartitem.fasttracksubtotal;
              totalfee = parseFloat(totalfee);
              if (totalfee < 0) {
                totalfee = 0;
              }
              console.log("totalfee", totalfee);
              formData_fast.append("ordertotal", totalfee);
              formData_fast.append("discount_amount", discount_amount);
              formData_fast.append("voucher", discount_coupon_applied);
            }
            fintotvalue = parseFloat(fintotvalue) + parseFloat(totalfee);
            encryptStorage.setItem("final_amount_paid", fintotvalue);
            console.log("fintotvalue ftt", fintotvalue);
            formData_fast.append("uuid", thing.getLocalData("uuid"));
            formData_fast.append(
              "orderreference",
              encryptStorage.getItem("ftt_order_ref")
            );
            formData_fast.append(
              "orderreference_wtpre",
              encryptStorage.getItem("orefwithoutprefix")
            );
            formData_fast.append("email_consent", thing.email_consent);
            formData_fast.append("slug", thing.setbrandid);
            formData_fast.append("product", "FTT");
            formData_fast.append("login_type", "SE");
            formData_fast.append("is_guest", thing.is_guest);
            formData_fast.append("guesttomember", thing.guesttomember);
            encryptStorage.setItem("is_guest", thing.is_guest);
            encryptStorage.setItem("guesttomember", thing.guesttomember);
            formData_fast.append("country", thing.country);

            object = {};
            formData_fast.forEach(function (value, key) {
              object[key] = value;
            });
            jsona = JSON.stringify(object);

            axios.post(
              "https://api-frankfurt.rezcomm.com/orderlogs/prepayment",
              jsona,
              {
                headers: {
                  b1: b1saip,
                  v2: v2saip,
                  c2s: c2saip,
                  a1: a1aip,
                  v1: v1aip,
                  c1: uidgenaip,
                },
              }
            );
            axios
              .post(
                encryptStorage.getItem("rez_dev_k").VUE_APP_DOMAIN_DEVHUB +
                  "hubapmydbauth/sqsregister/livesqs_carparking.php",
                formData_fast,
                {
                  headers: {
                    "Content-Type": "multipart/form-data",
                    b1: b1saip,
                    v2: v2saip,
                    c2s: c2saip,
                    a1: a1aip,
                    v1: v1aip,
                    c1: uidgenaip,
                  },
                }
              )
              .then((response) => {
                console.log(response);
              });
          }, 3000);
        }

        var thingu = this;
        if (typeof this.lounge_cartitem !== "undefined") {
          setTimeout(function () {
            let myFormsettings_lng = document.getElementById("payment-process");
            let formData_lng = new FormData(myFormsettings_lng);
            formData_lng.append("title", thingu.title);
            formData_lng.append(
              "first_name",
              encodeURIComponent(thingu.firstname)
            );
            formData_lng.append(
              "last_name",
              encodeURIComponent(thingu.surname)
            );
            formData_lng.append("mobilenumber", thingu.mobilenumber);
            formData_lng.append("email", thingu.email);
            formData_lng.append("phonecode", thingu.phonecode);
            formData_lng.append(
              "post_code",
              encodeURIComponent(thingu.postcode)
            );
            formData_lng.append(
              "address_line_1",
              encodeURIComponent(thingu.address)
            );
            formData_lng.append(
              "address_line_2",
              encodeURIComponent(thingu.address_line_2)
            );
            formData_lng.append("city", encodeURIComponent(thingu.town));
            formData_lng.append("state", encodeURIComponent(thingu.state));
            formData_lng.append(
              "vehicle_vrn",
              encodeURIComponent(thingu.vehicle_vrn)
            );
            formData_lng.append(
              "term_condition",
              encodeURIComponent(thingu.term_condition)
            );
            formData_lng.append(
              "vrn_color",
              encodeURIComponent(thingu.vrn_color)
            );
            formData_lng.append(
              "vrn_make",
              encodeURIComponent(thingu.vrn_make)
            );
            formData_lng.append(
              "vrn_model",
              encodeURIComponent(thingu.vrn_model)
            );
            formData_lng.append(
              "cart",
              JSON.stringify(encryptStorage.getItem("lounge_cart"))
            );
            formData_lng.append("outboundFlight", thingu.outboundFlight);
            formData_lng.append("inboundFlight", thingu.inboundFlight);

            formData_lng.append("orderstatus", "Pending");
            formData_lng.append("paymentstatus", "Pending");
            let totalfee = 0;
            if (thingu.getLocalDataoo("discount_amount") === null) {
              formData_lng.append(
                "ordertotal",
                thingu.lounge_cartitem.loungesubtotal
              );
              totalfee = thingu.lounge_cartitem.loungesubtotal;
              formData_lng.append("discount_amount", "0.00");
              formData_lng.append("voucher", "");
            } else {
              let discount_amount = encryptStorage.getItem("discount_amount");
              let discount_coupon_applied = encryptStorage.getItem(
                "discount_coupon_applied"
              );
              console.log("discount_coupon_applied", discount_coupon_applied);
              console.log("discount_amount", discount_amount);
              discount_amount = parseFloat(discount_amount);
              console.log("discount_amount", discount_amount);
              totalfee = thingu.lounge_cartitem.loungesubtotal;
              totalfee = parseFloat(totalfee);
              if (totalfee < 0) {
                totalfee = 0;
              }
              console.log("totalfee", totalfee);
              formData_lng.append("ordertotal", totalfee);
              formData_lng.append("discount_amount", discount_amount);
              formData_lng.append("voucher", discount_coupon_applied);
            }
            fintotvalue = parseFloat(fintotvalue) + parseFloat(totalfee);
            encryptStorage.setItem("final_amount_paid", fintotvalue);
            console.log("fintotvalue lng", fintotvalue);
            formData_lng.append("uuid", thingu.getLocalData("uuid"));

            formData_lng.append(
              "orderreference",
              encryptStorage.getItem("lng_order_ref")
            );
            formData_lng.append(
              "orderreference_wtpre",
              encryptStorage.getItem("orefwithoutprefix")
            );

            formData_lng.append("email_consent", thingu.email_consent);
            formData_lng.append("slug", thingu.setbrandid);
            formData_lng.append("product", "LNG");
            formData_lng.append("login_type", "SE");
            formData_lng.append("is_guest", thingu.is_guest);
            formData_lng.append("guesttomember", thingu.guesttomember);
            encryptStorage.setItem("is_guest", thingu.is_guest);
            encryptStorage.setItem("guesttomember", thingu.guesttomember);
            formData_lng.append("country", thingu.country);

            object = {};
            formData_lng.forEach(function (value, key) {
              object[key] = value;
            });
            jsona = JSON.stringify(object);

            axios.post(
              "https://api-frankfurt.rezcomm.com/orderlogs/prepayment",
              jsona,
              {
                headers: {
                  b1: b1saip,
                  v2: v2saip,
                  c2s: c2saip,
                  a1: a1aip,
                  v1: v1aip,
                  c1: uidgenaip,
                },
              }
            );
            axios
              .post(
                encryptStorage.getItem("rez_dev_k").VUE_APP_DOMAIN_DEVHUB +
                  "hubapmydbauth/sqsregister/livesqs_carparking.php",
                formData_lng,
                {
                  headers: {
                    "Content-Type": "multipart/form-data",
                    b1: b1saip,
                    v2: v2saip,
                    c2s: c2saip,
                    a1: a1aip,
                    v1: v1aip,
                    c1: uidgenaip,
                  },
                }
              )
              .then((response) => {
                console.log(response);
              });
          }, 3000);
        }
        var thingy = this;
        thingy.preslotconfirm(
          fintotvalue,
          thingy.getLocalData("uuid"),
          encryptStorage.getItem("orefwithoutprefix")
        );
      }
    },

    preslotconfirm(total, uuid, orderreference) {
      if (this.cpkincart) {
        Swal.fire(
          "Info!",
          "Please wait, we are validating the slot availability one final time.",
          "info"
        );

        setTimeout(() => {
          Swal.close();
        }, 2000);
        let cc = encryptStorage.getItem("cart");
        let datafor_preconfirm = {
          venue_id: cc.venue_id,
          brand_id: this.setbrandid,
          booking_ref_id: cc.booking_ref_id,
          uuid: uuid,
        };

        let secsaa = genkeys(
          encryptStorage.getItem("rez_dev_k").VUE_APP_CPK_PRESLOT_CONFIRM_SECRETID,
          encryptStorage.getItem("rez_dev_k").VUE_APP_CPK_PRESLOT_CONFIRM_SECRETKEY
        );

        let b1sa = secsaa.b1s;
        let v2sa = secsaa.v2s;
        let a1a = secsaa.a1;
        let v1a = secsaa.v1;
        let c2sa = secsaa.c2s;
        let uidgena = secsaa.uidgen;
        var thingy = this;
        axios
          .post(
            encryptStorage.getItem("rez_dev_k").VUE_APP_DOMAIN_LIVESSO +
              "parking/frontend/carpark/slots/pre_confirm",
            datafor_preconfirm,
            {
              headers: {
                b1: b1sa,
                v2: v2sa,
                c2s: c2sa,
                a1: a1a,
                v1: v1a,
                c1: uidgena,
              },
            }
          )
          .then(
            (response) => {
              let datasent = JSON.parse(response.request.response);
              if (datasent.user_exists == "Y") {
                //process order, hide popup
                if (thingy.setbrandid == "HER") {
                  setTimeout(function () {
                    thingy.submitforpayment(
                      total,
                      thingy.getLocalData("uuid"),
                      encryptStorage.getItem("orefwithoutprefix")
                    );
                  }, 5000);
                } else {
                  this.showpayment(
                    total,
                    thingy.getLocalData("uuid"),
                    encryptStorage.getItem("orefwithoutprefix")
                  );
                }
              } else {
                //show alert order cannot be processed, delete cart
                Swal.fire(
                  "Error!",
                  "Sorry, there are no more slots available for the duration you are searching on this car park, please try your search again",
                  "error"
                ).then(() => {
                  thingy.goto_page("/");
                });
                /*setTimeout(function () {
                  thingy.goto_results();
                }, 3000);*/
              }
            },
            (error) => {
              thingy.loading_proceed = false;
              console.log(error);
            }
          );
      } else {
        //process order, hide popup
        setTimeout(() => {
          this.submitforpayment(total, uuid, orderreference);
        }, 5000);
      }
    },
    goto_page(url) {
      window.location.href = url;
    },
    formatDate_M_D_Y(date) {
      // when DD/MM/YY is passed returns MM/DD/YY for date picker widget
      date = date.split("/");
      date = date[1] + "/" + date[0] + "/" + date[2];
      return date;
    },
    encode_query_data(data) {
      const ret = [];
      for (let d in data)
        ret.push(encodeURIComponent(d) + "=" + encodeURIComponent(data[d]));
      return ret.join("&");
    },
    goto_results() {
      const data = {
        date1_date: this.formatDate_M_D_Y(
          this.formatDatedmy(this.cartitem.valid_from)
        ),
        date1_time: this.cartitem.start_time,
        date2_date: this.formatDate_M_D_Y(
          this.formatDatedmy(this.cartitem.valid_till)
        ),
        date2_time: this.cartitem.end_time,
        venue_select: this.getLocalData("venue_selected"),
        venue_select_name: this.getLocalData("venue_selected_name_cpk"),
      };
      const querystring = "?" + this.encode_query_data(data);
      let uri = "";
      uri = this.goto_page_url;
      this.goto_page(uri + querystring);
    },

    pay_submit() {
      this.pay_submit = true;
    },
    showpayment(total, uuid, orderreference) {
      let toto = encryptStorage.getItem("final_amount_paid");
      toto = parseFloat(toto).toFixed(2);
      console.log("toto", toto);
      console.log("total", total);
      let chdata =
        encryptStorage.getItem("rez_dev_k").VUE_APP_CHL_USD +
        this.setbrandid.toLowerCase() +
        orderreference +
        uuid +
        total;
      let hash = crypto.createHash("sha512");
      let transaction_token = hash.update(chdata, "utf-8").digest("hex");

      this.final_amount = total;
      this.transaction_token = transaction_token;
      this.final_orderreference = orderreference;
      this.final_uuid = uuid;
      encryptStorage.setItem("final_uuid", this.final_uuid);
      encryptStorage.setItem("final_orderreference", this.final_orderreference);
      this.loading_proceed = false;
      this.registeristrue = false;
      this.loginistrue = false;
      this.payform = true;
      window.scrollTo(0, 0);
      this.banner_headline =
        "Please complete the secure payment form below to complete your reservation";
    },

    submitforpayment(total, uuid, orderreference) {
      this.loading_proceed = true;
      //console.log("fintotvalue", total);
      //encryptStorage.setItem("final_amount_paid", total);
      let original_orderref = orderreference;
      let chdata =
        encryptStorage.getItem("rez_dev_k").VUE_APP_CHL +
        this.setbrandid +
        orderreference +
        parseFloat(encryptStorage.getItem("final_amount_paid")).toFixed(2);
      let hash = crypto.createHash("sha512");
      let transaction_token = hash.update(chdata, "utf-8").digest("hex");
      let pspdata = {
        amount: parseFloat(encryptStorage.getItem("final_amount_paid")).toFixed(
          2
        ),
        brand_id: this.setbrandid,
        order_ref: orderreference,
        transaction_token: transaction_token,
        success_url:
          "https://securepayservice.rezcomm.com/jccstaging/payprocess.php?uuid=" +
          this.getLocalData("uuid") +
          "&venue=" +
          this.getLocalData("venue_selected") +
          "&lang=" +
          this.lang +
          "&original_orderref=" +
          original_orderref,
      };

      let secsaa = genkeys(
        encryptStorage.getItem("rez_dev_k").VUE_APP_PAY_SECRETID,
        encryptStorage.getItem("rez_dev_k").VUE_APP_PAY_SECRETKEY
      );
      let b1sa = secsaa.b1s;
      let v2sa = secsaa.v2s;
      let a1a = secsaa.a1;
      let v1a = secsaa.v1;
      let c2sa = secsaa.c2s;
      let uidgena = secsaa.uidgen;
      axios
        .post(
          encryptStorage.getItem("rez_dev_k").VUE_APP_DOMAIN_LIVESSO + "payment/jcc/checkout/initiate",
          pspdata,
          {
            headers: {
              b1: b1sa,
              v2: v2sa,
              c2s: c2sa,
              a1: a1a,
              v1: v1a,
              c1: uidgena,
              secret_id: "ykogb5iweovNRh8RNVlxfPtyJPUaPayU",
              secret_key:
                "KBlu5ROOi8rCQlBfmMVJX1LK5cIBkhe5wP6pfCxElUKpaYnR0QmwFqNxiledGsIy",
            },
          }
        )
        .then(
          (response) => {
            this.emailid_loading = false;
            let datasent = JSON.parse(response.request.response);
            this.formdata_payform = datasent.form_data;
            setTimeout(function () {
              document.getElementById("paymentForm").submit();
            }, 2000);
          },
          (error) => {
            this.loading_proceed = false;
            console.log(error);
          }
        );
    },
    async proceedtologinuser() {
      //console.log('submit login check!');
      if (this.password == "") {
        Swal.fire({
          title: "Alert",
          icon: "error",
          text: "Please enter valid code.",
          confirmButtonText: "Close",
          showCloseButton: true,
        });
      } else {
        this.proceedtologinuser_loading = true;
        let emailentered = this.emailid;
        let passwordentered = this.password;
        let device_id = this.genHash(emailentered);
        let datasearch = {};
        datasearch = {
          brand_id: this.setbrandid,
          login_id: emailentered,
          otp_code: passwordentered,
          device_id: device_id,
        };
        let secsa = {};
        if (this.setbrandid == "HER") {
          secsa = genkeys(
            encryptStorage.getItem("rez_dev_k").VUE_APP_LOGIN_SECRETID_FRA,
            encryptStorage.getItem("rez_dev_k").VUE_APP_LOGIN_SECRETKEY_FRA
          );
        } else {
          secsa = genkeys(
            encryptStorage.getItem("rez_dev_k").VUE_APP_LOGIN_SECRETID,
            encryptStorage.getItem("rez_dev_k").VUE_APP_LOGIN_SECRETKEY
          );
        }
        let b1s = secsa.b1s;
        let v2s = secsa.v2s;
        let a1 = secsa.a1;
        let v1 = secsa.v1;
        let c2s = secsa.c2s;
        let uidgen = secsa.uidgen;
        let ur = "";
        if (this.setbrandid == "HER") {
          ur =
            encryptStorage.getItem("rez_dev_k").VUE_APP_DOMAIN_DEVAWS_FRA + "sso/frontend/auth/login";
        } else {
          ur = encryptStorage.getItem("rez_dev_k").VUE_APP_DOMAIN_DEVAWS + "sso/frontend/auth/login";
        }
        axios
          .post(ur, datasearch, {
            headers: {
              b1: b1s,
              v2: v2s,
              c2s: c2s,
              a1: a1,
              v1: v1,
              c1: uidgen,
            },
          })
          .then(
            (response) => {
              this.emailid_loading = false;
              let datasent = JSON.parse(response.request.response);
              if (datasent.code.toString() == "1") {
                this.accessToken = datasent.msg.accessToken;
                this.refreshToken = datasent.msg.refreshToken;
                let uuid = datasent.msg.user_det.uuid.toString();
                this.setLocalData("uuid", uuid);
                let datasearch = {
                  slug: this.setbrandid,
                  uid: uuid,
                };
                let secsaa = {};
                if (this.setbrandid == "HER") {
                  secsaa = genkeys(
                    encryptStorage.getItem("rez_dev_k").VUE_APP_USERDET_SECRETID_FRA,
                    encryptStorage.getItem("rez_dev_k").VUE_APP_USERDET_SECRETKEY_FRA
                  );
                } else {
                  secsaa = genkeys(
                    encryptStorage.getItem("rez_dev_k").VUE_APP_USERDET_SECRETID,
                    encryptStorage.getItem("rez_dev_k").VUE_APP_USERDET_SECRETKEY
                  );
                }
                let b1sa = secsaa.b1s;
                let v2sa = secsaa.v2s;
                let a1a = secsaa.a1;
                let v1a = secsaa.v1;
                let c2sa = secsaa.c2s;
                let uidgena = secsaa.uidgen;
                if (this.setbrandid == "HER") {
                  ur = encryptStorage.getItem("rez_dev_k").VUE_APP_DOMAIN_DEVAWS_FRA;
                } else {
                  ur = encryptStorage.getItem("rez_dev_k").VUE_APP_DOMAIN_DEVAWS;
                }
                axios
                  .post(ur + "userdetails/", datasearch, {
                    headers: {
                      b1: b1sa,
                      v2: v2sa,
                      c2s: c2sa,
                      a1: a1a,
                      v1: v1a,
                      c1: uidgena,
                    },
                  })
                  .then(
                    (response) => {
                      this.emailid_loading = false;
                      let userdatasent = JSON.parse(response.request.response);
                      this.proceedtologinuser_loading = false;
                      //console.log(userdatasent);
                      if (userdatasent.user_exists == "Y") {
                        this.registeristrue = true;
                        this.loginistrue = false;
                        this.passistrue = false;
                        this.userexists = true;
                        this.updateHeader += 1;
                        sessionStorage.setItem("session_uuid", uuid);
                        let userdata = userdatasent.result[0];
                        encryptStorage.setItem("session_userdata", userdata);
                        this.title = userdata.title;
                        this.firstname = decodeURI(userdata.first_name);
                        this.surname = decodeURI(userdata.last_name);
                        this.email = userdata.email;
                        this.email_confirm = userdata.email;
                        this.address = decodeURI(
                          decodeURI(userdata.address_line_1)
                        );
                        this.address_line_2 = decodeURI(
                          decodeURI(userdata.address_line_2)
                        );
                        this.postcode = decodeURI(userdata.post_code);
                        this.state = decodeURI(userdata.state);
                        this.town = decodeURI(userdata.city);
                        //this.country = userdata.country;
                        this.phonecode = userdata.phonecode;
                        this.mobilenumber = userdata.mobilenumber;
                      } else {
                        Swal.fire({
                          title: "Alert",
                          icon: "error",
                          text: "User Not found, please contact administrator",
                          confirmButtonText: "Close",
                          showCloseButton: true,
                        });
                      }
                    },
                    (error) => {
                      console.log(error);
                      this.proceedtologinuser_loading = false;
                    }
                  );
              }
              if (datasent.code.toString() == "26") {
                Swal.fire({
                  title: "Alert",
                  icon: "error",
                  text: "Invalid Credentials",
                  confirmButtonText: "Close",
                  showCloseButton: true,
                });
              }
              if (
                datasent.code.toString() == "37" ||
                datasent.code.toString() == "36"
              ) {
                Swal.fire({
                  title: "Alert",
                  icon: "error",
                  text: datasent.msg,
                  confirmButtonText: "Close",
                  showCloseButton: true,
                });
              }
            },
            (error) => {
              console.log(error);
              this.proceedtologinuser_loading = false;
            }
          );
      }
    },

    findyourvrn() {
      this.loading_vrn = true;
      let vehicle_vrn = this.vehicle_vrn;
      this.showvrnfields = false;
      this.showvrnfields_manually = false;
      if (vehicle_vrn == "") {
        Swal.fire("Error!", "Please enter vrn number", "error");
        this.loading_vrn = false;
      } else {
        this.findingVRN = true;
        let datasearch = { vrn: vehicle_vrn };
        axios
          .post(encryptStorage.getItem("rez_dev_k").VUE_APP_DOMAIN_LIVESSO + "verifyvrn/", datasearch, {
            headers: {
              secretid: "38eb6e4255600abb3e09a1b19a2df9a4",
              secretkey: "5c57a045451d59c080c27be1225733f26fe97b614f581120",
            },
          })
          .then(
            (response) => {
              this.emailid_loading = false;
              let datasent = JSON.parse(response.request.response);
              if (datasent.data[0]) {
                this.vrn_color = datasent.data[0].primaryColour;
                this.vrn_make = datasent.data[0].make;
                this.vrn_model = datasent.data[0].model;
                this.showvrnfields = true;
                this.showvrnfields_manually = false;
                this.vrnfields_readonly = false;
                this.loading_vrn = false;
              } else {
                this.vrn_color = "";
                this.vrn_make = "";
                this.vrn_model = "";
                this.vrnfields_readonly = false;
                this.loading_vrn = false;
                Swal.fire({
                  title: "Sorry",
                  html: "We could not find the car details.",
                  showCancelButton: true,
                  confirmButtonText: `Enter Manually`,
                }).then((result) => {
                  if (result.isConfirmed) {
                    this.showvrnfields = !this.showvrnfields;
                  }
                });
                Swal.fire({
                  title: "Car Details Unknown",
                  html: "We could not find your car details, would you like to proceed?",
                  confirmButtonText: `Yes`,
                }).then((result) => {
                  if (result.isConfirmed) {
                    this.showvrnfields = true;
                  }
                });
              }
              this.findingVRN = false;
              this.loading_vrn = false;
            },
            (error) => {
              console.log(error);
              this.findingVRN = false;
              this.loading_vrn = false;
            }
          );
      }
    },
    getbranded() {
      axios
        .post(
          encryptStorage.getItem("rez_dev_k").VUE_APP_DOMAIN_DEVHUB +
            "hubapmydbauth/brandapi/getbrnslg_dev.php",
          "",
          {
            headers: {
              secret_id: encryptStorage.getItem("rez_dev_k").VUE_APP_BRNDED_SECRETID,
              secret_key: encryptStorage.getItem("rez_dev_k").VUE_APP_BRNDED_SECRETKEY,
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          //console.log(response.data.slug);
          //console.log(response.data.currency);
          if (response.data.code == "1") {
            this.setbrandid = response.data.slug;
            this.currency = response.data.currency;
            if (response.data.slug == "HER") {
              this.currency = "€";
              this.phonecode = "+357";
            }
            this.loadTranslations();
            this.getBrandData();
          }
        });
    },
    check_for_session() {
      //checks for session
      console.log("check_for_session", sessionStorage.getItem("session_uuid"));

      if (sessionStorage.getItem("session_uuid") === null) {
        //do nothing
      } else {
        let userdata = encryptStorage.getItem("session_userdata");
        if (userdata !== undefined) {
          this.setLocalData("uuid", sessionStorage.getItem("session_uuid"));
          this.registeristrue = true;
          this.loginistrue = false;
          this.passistrue = false;
          this.userexists = true;
          this.updateHeader += 1;
          this.title = userdata.title;
          this.firstname = decodeURI(userdata.first_name);
          this.surname = decodeURI(userdata.last_name);
          this.email = userdata.email;
          this.emailid = userdata.email;
          this.emailid_wo = userdata.email;
          this.password = "000000";
          this.email_confirm = userdata.email;
          this.address = decodeURI(decodeURI(userdata.address_line_1));
          this.address_line_2 = decodeURI(decodeURI(userdata.address_line_2));
          this.postcode = decodeURI(userdata.post_code);
          this.state = decodeURI(userdata.state);
          this.town = decodeURI(userdata.city);
          //this.country = userdata.country;
          this.phonecode = userdata.phonecode;
          this.mobilenumber = userdata.mobilenumber;
        }
      }
    },
    async get_rez_data_k()
    {
      if (typeof encryptStorage.getItem("rez_dev_k") === "undefined") 
      {
        let _this = this;
        await axios.get('https://devhub.rezcomm.com/hubapmydbauth/livedata/index.php')
        .then(response => {

        const key = 'XwB?au@qy*^y!r6R&wV8fVuSXmGKf3Sn';
        const encryptedData = response.data;
        let dec = _this.decrypt_custom(key, encryptedData);
        
        encryptStorage.setItem("rez_dev_k",dec);
        
             
        })
        .then(() => {
          _this.getbranded();
        }
        )
        .catch(error => {
        console.error(error);
        });
        }
        else
        {
          this.getbranded();
        }
    },
    decrypt_custom(key, data) {
      
      const decodedData = Buffer.from(data, 'base64').toString('utf8');
        const parts = decodedData.split('::');
    
        // Extract IV
        key = Buffer.from(parts[0]);
        let iv = Buffer.from(parts[2], 'hex');
    
        // Extract encrypted data
        const encryptedData = Buffer.from(parts[1], 'base64');
    
        // Create decipher object with correct IV and key
        const decipher = crypto.createDecipheriv('aes-256-cbc', key, iv);
    
        // Update decryption with encrypted data
        let decrypted = decipher.update(encryptedData);
    
        // Finalize the decryption
        decrypted = Buffer.concat([decrypted, decipher.final()]);
    
        return decrypted.toString('utf8');
}    
  },
  created() {},
  mounted() {
    this.get_rez_data_k();

    this.cartitem = encryptStorage.getItem("cart");
    this.cartitem_park = encryptStorage.getItem("cart");
    this.fasttrack_cartitem = encryptStorage.getItem("fasttrack_cart");
    this.lounge_cartitem = encryptStorage.getItem("lounge_cart");
    if (typeof this.cartitem_park !== "undefined") {
      this.vehicle_vrn = "";
    } else {
      this.vehicle_vrn = "NA";
    }
    console.log("this.cartitem_park", this.cartitem_park);
    console.log("this.fasttrack_cartitem", this.fasttrack_cartitem);
    console.log("this.lounge_cartitem", this.lounge_cartitem);
    console.log("this.vehicle_vrn", this.vehicle_vrn);
    let finprice = 0;
    if (typeof this.cartitem !== "undefined") {
      finprice = finprice + parseFloat(this.cartitem.price);
    } else {
      this.cartitem = {};
    }

    if (typeof this.lounge_cartitem !== "undefined") {
      finprice = finprice + parseFloat(this.lounge_cartitem.loungesubtotal);
    }

    if (typeof this.fasttrack_cartitem !== "undefined") {
      finprice =
        finprice + parseFloat(this.fasttrack_cartitem.fasttracksubtotal);

      let object = this.fasttrack_cartitem;
      for (const property in object) {
        console.log(`${property}: ${object[property]}`);

        switch (property) {
          case "ADL":
            for (let i = 0; i < object[property]; i++) {
              this.fasttrack_passengers_ADL.push({
                title: this.getrans("Rather not say"),
                firstname: "Adult " + i,
                surname: "Adult " + i,
              });
            }
            break;
          case "CHD":
            for (let i = 0; i < object[property]; i++) {
              this.fasttrack_passengers_CHD.push({
                title: this.getrans("Rather not say"),
                firstname: "Child " + i,
                surname: "Child " + i,
              });
            }
            break;
          case "INF":
            for (let i = 0; i < object[property]; i++) {
              this.fasttrack_passengers_INF.push({
                title: this.getrans("Rather not say"),
                firstname: "Infant " + i,
                surname: "Infant " + i,
              });
            }
            break;
        }
      }

      console.log(
        "this.fasttrack_passengers_ADL",
        this.fasttrack_passengers_ADL
      );
    }
    this.finprice = finprice.toFixed(2);
    console.log("finprice", this.finprice);
    this.cartloaded = true;
    this.check_for_session();
  },
  updated() {
    this.checkHomeRedirect();
  },
};
</script>

<style lang="scss">
@import "@/assets/sass/normalise.scss";
@import "@/assets/sass/bodyStyle.scss";
@import "@/assets/sass/formStyles.scss";
// .tab-basket {
//   display: none !important;
// }

#demoPayButton {
  i {
    display: none;
  }
}

#demoPayButton {
  pointer-events: none;
  filter: grayscale(100%);
  cursor: not-allowed;
}

.cvv-valid.ccnumber-valid.ccexp-valid #demoPayButton {
  pointer-events: all;
  filter: grayscale(0%);
  cursor: pointer;
}

.cvv-valid.ccnumber-valid.ccexp-valid.submit_click #demoPayButton {
  pointer-events: none;
  filter: grayscale(100%);
  i {
    display: inline-block;
  }
}

.cvv-valid.ccnumber-valid.ccexp-valid.submit_click #psp-form {
  pointer-events: none;
}

.CollectJSInlineIframe {
  border: none;
  height: 55px !important;
  border-bottom: 1px solid#dddddd;
}
</style>
<style scoped lang="scss">
@import "@/assets/sass/variables.scss";

.standard-para,
.input-checkbox label {
  font-family: var(--details_text_font_family, inherit);
  font-size: var(--details_text_font_size, 1rem);
  font-weight: var(--details_text_font_weight, inherit);
  color: var(--details_text_font_color, #222);
}

.yourdetails-banner-container {
  height: 171px;
  background: var(
    --header_banner_background,
    transparent linear-gradient(#0871b9 0%, #034a94 100%) 0% 0% no-repeat
      padding-box
  );
  display: flex;
  align-items: center;

  @media screen and (max-width: 1260px) {
    padding: 0 1rem;
  }
}

.page-content {
  // outline: 1px solid red;
  max-width: 1300px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr;
  margin-top: -3.5rem;
  gap: 2rem;

  @media screen and (min-width: 960px) {
    grid-template-columns: 2fr 1fr;
  }

  padding: 1rem;

  &__form {
    // outline: 1px solid green;

    &--box-style {
      background: #ffffff;
      box-shadow: 0px 0px 6px #00000029;
      padding: 1em 1.375rem;
      margin-bottom: 2rem;
    }
  }

  &__form-details {
    position: relative;
    // padding: 1em 1rem 1rem 1.375rem;
    // padding-right: calc(1rem - 20px);
  }

  &__form-proceed {
    margin-bottom: 1rem;
    button {
      width: 100%;
      padding: 1em;
      font-family: var(--details_buttons_primary_font_family, inherit);
      font-size: var(--details_buttons_primary_font_size, 1rem);
      font-weight: var(--details_buttons_primary_font_weight, inherit);
      background: var(--details_buttons_primary_background, #034a94);
      color: var(--details_buttons_primary_font_color, #fff);
      border: var(--details_buttons_primary_border, none);
      border-radius: var(--details_buttons_primary_border_radius, 0.25rem);
    }
  }

  &__form-proceed.guest-btn {
    margin-bottom: 1rem;
    button {
      width: 100%;
      padding: 1em;
      font-family: var(--details_buttons_secondary_font_family, inherit);
      font-size: var(--details_buttons_secondary_font_size, 1rem);
      font-weight: var(--details_buttons_secondary_font_weight, inherit);
      background: var(--details_buttons_secondary_background, #e9e7e7);
      color: var(--details_buttons_secondary_font_color, #2f3e52);
      border: var(--details_buttons_secondary_border, none);
      border-radius: var(--details_buttons_secondary_border_radius, 0.25rem);
    }
  }

  &__form-btn {
    width: 100%;
    padding: 1em;
    font-family: var(--details_buttons_primary_font_family, inherit);
    font-size: var(--details_buttons_primary_font_size, 1rem);
    font-weight: var(--details_buttons_primary_font_weight, inherit);
    background: var(--details_buttons_primary_background, #034a94);
    color: var(--details_buttons_primary_font_color, #fff);
    border: var(--details_buttons_primary_border, none);
    border-radius: var(--details_buttons_primary_border_radius, 0.25rem);
  }

  &__form-title {
    clear: both;
    padding: 0.25rem 0 1rem;
    font-family: var(--details_headings_font_family, inherit);
    font-size: var(--details_headings_font_size, 1.25rem);
    font-weight: var(--details_headings_font_weight, bold);
    color: var(--details_headings_font_color, #0a3b74);
  }

  &__basket-subtotal {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    .page-content__form-title {
      padding: 0;
    }
    button {
      margin-top: 1rem;
      width: 100%;
      padding: 1em;
      background: #034a94;
      color: #fff;
      border: 0px;
      border-radius: 0.25rem;
      @media screen and (min-width: 960px) {
        display: none;
      }
    }
  }

  &__form-title--price {
    font-size: 1.5rem;
    font-family: var(--basket_price_font_family, inherit);
    font-weight: var(--basket_price_font_weight, bold);
    color: var(--basket_price_font_color, #236ca3);
  }

  &__basket {
    // outline: 1px solid blue;
    @media screen and (min-width: 960px) {
      display: block;
    }

    &--box-style {
      background: #ffffff;
      box-shadow: 0px 0px 6px #00000029;
      padding: 1em 1.375rem;
      margin-bottom: 1rem;
    }
  }

  &__hide-section-on-mobile {
    display: none;
    @media screen and (min-width: 960px) {
      display: block;
    }
  }
}

.postcode-message {
  padding: 1rem 0;
  font-size: 0.875rem;
}

.input-checkbox label {
  cursor: default;
}

.fastest-option {
  display: flex;
  justify-content: space-between;

  &__outer {
    display: flex;
    flex-wrap: nowrap;
    align-self: flex-start;
    background-size: cover;
    background-repeat: no-repeat;
    background-position-y: center;
  }

  &__inner {
    height: auto;
    padding: 0.5rem 1.5rem;
    // background: linear-gradient(102deg, #DB9B03 0%, #DF2B1F 100%) 0% 0% no-repeat;
    color: #fff;
    margin-left: 0.5rem;
  }
}

.bolder-text {
  // color: #1a2a40;
  // font-size: 1rem;
  // font-weight: 600;
  font-family: var(--details_subheadings_font_family, inherit);
  font-size: var(--details_subheadings_font_size, 1rem);
  font-weight: var(--details_subheadings_font_weight, 600);
  color: var(--details_subheadings_font_color, #1a2a40);
}

.block-wrap-question-icon--in-title {
  width: auto;
  display: inline;
  float: right;
  padding: 0;
}

.inputs-heading {
  display: block;
}

.passenger-block {
  padding: 1rem;
  padding-bottom: 0rem;
  padding-right: 0rem;
  margin-bottom: 1rem;
  border: 1px solid #eee;
  .inputs-heading {
    font-weight: bold;
    color: #0a3b74;
    padding-bottom: 1rem;
  }
}

.bank-cards {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  align-items: center;
  padding-bottom: 3rem;
  i {
    color: #0a3b74;
    font-size: 1.5rem;
  }
  img {
    display: block;
    height: 1.6rem;
    width: auto;
  }
}
</style>
